/* Vector text halo pipeline (opentype.js based) — proper offset of actual
   glyph outlines instead of raster mask tracing. Produces parallel borders
   that follow letter shapes exactly. Loaded lazily. */
(function(){
  var _otCache={};       // family → Promise<opentype.Font>
  var _otLib=null;       // opentype.js module (lazy)
  function loadOT(){
    if(_otLib)return Promise.resolve(_otLib);
    return import('https://cdn.jsdelivr.net/npm/opentype.js@1.3.4/dist/opentype.module.min.js')
      .then(function(m){_otLib=m.default||m;return _otLib;});
  }
  /* Find the font binary URL by scanning document.styleSheets for the
     matching @font-face rule. Returns null if not found (e.g. system font
     with no @font-face declaration). */
  function findFontUrl(family){
    family=String(family||'').replace(/['"]/g,'').trim();
    var sheets=document.styleSheets,best=null;
    for(var si=0;si<sheets.length;si++){
      try{
        var rules=sheets[si].cssRules||sheets[si].rules;
        if(!rules)continue;
        for(var ri=0;ri<rules.length;ri++){
          var r=rules[ri];
          if(r.type===5||(r.cssText&&r.cssText.indexOf('@font-face')===0)){
            var fam=r.style&&r.style.fontFamily?r.style.fontFamily.replace(/['"]/g,'').trim():'';
            if(fam.toLowerCase()===family.toLowerCase()){
              var src=r.style.src||(r.cssText.match(/src:([^;]+)/i)||[])[1]||'';
              var urls=src.match(/url\(['"]?([^'")]+)['"]?\)\s*format\(['"]?(woff2|truetype|opentype)['"]?\)/gi)||
                       src.match(/url\(['"]?([^'")]+)['"]?\)/gi)||[];
              /* Prefer woff2 → ttf → first match. Need to re-extract URL. */
              for(var u=0;u<urls.length;u++){
                var m=urls[u].match(/url\(['"]?([^'")]+)['"]?\)/);
                if(m){
                  if(!best)best=m[1];
                  if(/woff2|truetype/i.test(urls[u]))best=m[1];
                }
              }
              if(best)return best;
            }
          }
        }
      }catch(e){/* cross-origin sheet, skip */}
    }
    return null;
  }
  /* Hardcoded font URLs from @fontsource CDN — works regardless of whether
     the page has the @font-face rules loaded. Covers every font in the
     studio's font picker plus system-font substitutes. */
  function fsUrl(slug){return 'https://cdn.jsdelivr.net/npm/@fontsource/'+slug+'/files/'+slug+'-latin-400-normal.woff2';}
  var FONT_URLS={
    'anton':fsUrl('anton'),
    'inter':fsUrl('inter'),
    'poppins':fsUrl('poppins'),
    'bebas neue':fsUrl('bebas-neue'),
    'oswald':fsUrl('oswald'),
    'lobster':fsUrl('lobster'),
    'pacifico':fsUrl('pacifico'),
    'bangers':fsUrl('bangers'),
    'permanent marker':fsUrl('permanent-marker'),
    'caveat':fsUrl('caveat'),
    'dancing script':fsUrl('dancing-script'),
    'playfair display':fsUrl('playfair-display'),
    'press start 2p':fsUrl('press-start-2p'),
    'righteous':fsUrl('righteous'),
    'russo one':fsUrl('russo-one'),
    'satisfy':fsUrl('satisfy'),
    'fredoka one':fsUrl('fredoka-one'),
    'bungee':fsUrl('bungee'),
    'luckiest guy':fsUrl('luckiest-guy'),
    'black ops one':fsUrl('black-ops-one'),
    'raleway':fsUrl('raleway'),
    'montserrat':fsUrl('montserrat'),
    'quicksand':fsUrl('quicksand')
  };
  /* System-font substitutes (no opentype-readable binary available locally). */
  var FONT_SUBSTITUTES={
    'impact':'anton','arial black':'anton','arial':'inter','helvetica':'inter',
    'times new roman':'playfair display','georgia':'playfair display',
    'courier new':'press start 2p','verdana':'inter'
  };
  function fontUrlOrFallback(family){
    var key=String(family||'').toLowerCase().replace(/['"]/g,'').trim();
    if(FONT_URLS[key])return FONT_URLS[key];
    var sub=FONT_SUBSTITUTES[key];
    if(sub&&FONT_URLS[sub]){
      console.info('[sl2-vector-text] substituting',family,'→',sub);
      return FONT_URLS[sub];
    }
    /* Last resort: try the page's @font-face rules. */
    return findFontUrl(family);
  }
  function loadFont(family){
    var key=family.toLowerCase();
    if(_otCache[key])return _otCache[key];
    _otCache[key]=loadOT().then(function(ot){
      var url=fontUrlOrFallback(family);
      if(!url)throw new Error('No font URL for '+family);
      return new Promise(function(res,rej){
        ot.load(url,function(err,font){
          if(err)rej(err);else res(font);
        });
      });
    });
    return _otCache[key];
  }
  /* Adaptive curve flattening: sample enough segments that the chord error
     stays under ~0.75px. For Q/C curves, more curvature ⇒ more segments. */
  function flatQuad(p0,p1,p2,out,tol){
    /* Estimate by control polygon length / chord length ratio. */
    var cl=Math.hypot(p1[0]-p0[0],p1[1]-p0[1])+Math.hypot(p2[0]-p1[0],p2[1]-p1[1]);
    var n=Math.max(4,Math.ceil(cl/Math.max(1,tol*4)));
    for(var i=1;i<=n;i++){
      var t=i/n,u=1-t;
      out.push([u*u*p0[0]+2*u*t*p1[0]+t*t*p2[0],u*u*p0[1]+2*u*t*p1[1]+t*t*p2[1]]);
    }
  }
  function flatCubic(p0,p1,p2,p3,out,tol){
    var cl=Math.hypot(p1[0]-p0[0],p1[1]-p0[1])+Math.hypot(p2[0]-p1[0],p2[1]-p1[1])+Math.hypot(p3[0]-p2[0],p3[1]-p2[1]);
    var n=Math.max(6,Math.ceil(cl/Math.max(1,tol*4)));
    for(var i=1;i<=n;i++){
      var t=i/n,u=1-t;
      out.push([
        u*u*u*p0[0]+3*u*u*t*p1[0]+3*u*t*t*p2[0]+t*t*t*p3[0],
        u*u*u*p0[1]+3*u*u*t*p1[1]+3*u*t*t*p2[1]+t*t*t*p3[1]
      ]);
    }
  }
  /* Convert an opentype.js Path's commands into polygon subpaths.
     Compound glyphs produce multiple subpaths (e.g., O has outer + hole).
     Holes are preserved via opposite winding direction; Clipper unions
     correctly with pftEvenOdd to retain inner holes. */
  function pathToPolygons(otPath,tol){
    tol=tol||0.75;
    var subs=[],cur=null;
    var cmds=otPath.commands;
    for(var i=0;i<cmds.length;i++){
      var c=cmds[i];
      if(c.type==='M'){
        if(cur&&cur.length>2)subs.push(cur);
        cur=[[c.x,c.y]];
      } else if(c.type==='L'){
        if(cur)cur.push([c.x,c.y]);
      } else if(c.type==='Q'){
        if(!cur)continue;
        flatQuad(cur[cur.length-1],[c.x1,c.y1],[c.x,c.y],cur,tol);
      } else if(c.type==='C'){
        if(!cur)continue;
        flatCubic(cur[cur.length-1],[c.x1,c.y1],[c.x2,c.y2],[c.x,c.y],cur,tol);
      } else if(c.type==='Z'){
        if(cur&&cur.length>2)subs.push(cur);
        cur=null;
      }
    }
    if(cur&&cur.length>2)subs.push(cur);
    return subs;
  }
  /* Apply Fabric text object's transform to a list of polygon points.
     Fabric text uses originX/Y at center by default. */
  function applyFabricTransform(polys,textObj){
    var f=window.fabric;if(!f||!textObj)return polys;
    textObj.setCoords();
    var m=textObj.calcTransformMatrix();
    return polys.map(function(sub){
      return sub.map(function(p){
        var tp=f.util.transformPoint({x:p[0],y:p[1]},m);
        return [tp.x,tp.y];
      });
    });
  }
  /* Build the offset contour from a Fabric IText object using its actual
     font glyph outlines. Returns {offsetSvg, offsetPts} matching the format
     the section's drawCutline() expects, or null on failure. */
  window._sl2GetTextPathContour=function(canvas,offsetPx){
    if(!window.ClipperLib)return Promise.resolve(null);
    var texts=canvas.getObjects().filter(function(o){return o.type==='i-text'&&!o._isCutline&&!o._isScissorIcon&&o.visible!==false;});
    if(!texts.length)return Promise.resolve(null);
    /* Load fonts for all distinct families in parallel. */
    var fams={};texts.forEach(function(t){fams[t.fontFamily||'Impact']=true;});
    var famList=Object.keys(fams);
    return Promise.all(famList.map(function(f){return loadFont(f).catch(function(e){console.warn('[sl2-vector-text] font load failed:',f,e);return null;});}))
      .then(function(fontObjs){
        var fontMap={};
        famList.forEach(function(f,i){if(fontObjs[i])fontMap[f]=fontObjs[i];});
        var CS=5000,allPolys=[];
        texts.forEach(function(t){
          var font=fontMap[t.fontFamily||'Impact'];
          if(!font)return;
          /* Walk each line, get path with proper baseline; opentype's
             font.getPath positions glyphs at (x, y_baseline) in font units. */
          var fontSize=t.fontSize||40;
          var lines=String(t.text||'').split('\n');
          var lineHeight=t.lineHeight||1.16;
          /* Fabric text bounds: width × height in object's local space. We
             render glyphs into local space then apply the object transform. */
          var localW=t.width,localH=t.height;
          var ascender=font.ascender/font.unitsPerEm*fontSize;
          var lineH=fontSize*lineHeight;
          var localPolys=[];
          lines.forEach(function(line,li){
            if(!line)return;
            var pathCmds=font.getPath(line,0,ascender+li*lineH,fontSize);
            var pl=t.textAlign||'left';
            var lineW=font.getAdvanceWidth(line,fontSize);
            var dx=pl==='center'?(localW-lineW)/2:pl==='right'?(localW-lineW):0;
            var subs=pathToPolygons(pathCmds,12);
            subs.forEach(function(s){localPolys.push(s.map(function(p){return[p[0]+dx,p[1]];}));});
          });
          /* Translate from local origin (top-left) to the centered origin
             that Fabric's calcTransformMatrix expects. */
          var translatedPolys=localPolys.map(function(s){return s.map(function(p){return[p[0]-localW/2,p[1]-localH/2];});});
          var worldPolys=applyFabricTransform(translatedPolys,t);
          worldPolys.forEach(function(p){allPolys.push(p);});
        });
        if(!allPolys.length){console.warn('[sl2-vector-text] no glyph polys');return null;}
        /* Default mode: 'union' — all glyphs unioned, then a single ClipperOffset
           with jtMiter (sharp corners) produces a constant-distance offset of the
           combined text shape. No bridges, no close, no smoothing. The border
           runs parallel to the actual letter outlines. Override via
           window._sl2TextHaloMode. */
        var MODE=window._sl2TextHaloMode||'union';
        var JOIN=window._sl2TextJoinType==='round'?ClipperLib.JoinType.jtRound:ClipperLib.JoinType.jtMiter;
        var totalGlyphPolys=allPolys.length;
        function logCounts(stage,paths){
          console.info('[sl2-vector-text]',MODE,'mode |',stage,'| glyphs:',texts.length,'glyph polys:',totalGlyphPolys,'paths:',paths.length);
        }
        function pathsToOutput(paths){
          var svgParts=[],ptsList=[];
          for(var hh=0;hh<paths.length;hh++){
            var p=paths[hh];if(!p||p.length<3)continue;
            var pts=p.map(function(pt){return[pt.X/CS,pt.Y/CS];});
            var sub='M '+pts[0][0]+' '+pts[0][1];
            for(var pi=1;pi<pts.length;pi++) sub+=' L '+pts[pi][0]+' '+pts[pi][1];
            sub+=' Z';
            svgParts.push(sub);ptsList.push(pts);
          }
          if(!svgParts.length){console.warn('[sl2-vector-text] no svg parts');return null;}
          var longest=0;
          for(var li=1;li<ptsList.length;li++)if(ptsList[li].length>ptsList[longest].length)longest=li;
          return {offsetSvg:svgParts.join(' '),offsetPts:ptsList[longest],allPts:ptsList};
        }
        /* Convert all glyph polys to Clipper format once. */
        var clipperGlyphs=allPolys.map(function(g){return g.map(function(p){return{X:Math.round(p[0]*CS),Y:Math.round(p[1]*CS)};});});
        if(MODE==='perGlyph'){
          /* Per-glyph: offset each glyph polygon separately, never merge. */
          var perGlyphHalos=[];
          for(var gi=0;gi<clipperGlyphs.length;gi++){
            var coG=new ClipperLib.ClipperOffset(2,0.25*CS);
            coG.AddPath(clipperGlyphs[gi],JOIN,ClipperLib.EndType.etClosedPolygon);
            var hp=new ClipperLib.Paths();
            coG.Execute(hp,offsetPx*CS);
            for(var hi=0;hi<hp.length;hi++)if(ClipperLib.Clipper.Area(hp[hi])>0)perGlyphHalos.push(hp[hi]);
          }
          logCounts('perGlyph halos',perGlyphHalos);
          return pathsToOutput(perGlyphHalos);
        }
        /* Both 'union' and 'smartBridge' need the unioned-then-offset shape. */
        var uc=new ClipperLib.Clipper();
        uc.AddPaths(clipperGlyphs,ClipperLib.PolyType.ptSubject,true);
        var unioned=new ClipperLib.Paths();
        uc.Execute(ClipperLib.ClipType.ctUnion,unioned,ClipperLib.PolyFillType.pftEvenOdd,ClipperLib.PolyFillType.pftEvenOdd);
        if(!unioned.length){console.warn('[sl2-vector-text] union empty');return null;}
        var coU=new ClipperLib.ClipperOffset(2,0.25*CS);
        coU.AddPaths(unioned,JOIN,ClipperLib.EndType.etClosedPolygon);
        var sol=new ClipperLib.Paths();
        coU.Execute(sol,offsetPx*CS);
        if(!sol.length){console.warn('[sl2-vector-text] offset empty');return null;}
        if(MODE==='union'){
          logCounts('union+offset',sol);
          return pathsToOutput(sol);
        }
        /* smartBridge: morphological close to fill narrow concave necks
           between adjacent letter halos with smooth rounded bridges. Keeps
           all paths — wide gaps stay separate. */
        var neckR=Math.max(offsetPx*0.85,12)*CS;
        var coDil=new ClipperLib.ClipperOffset(2,0.25*CS);
        coDil.AddPaths(sol,JOIN,ClipperLib.EndType.etClosedPolygon);
        var dilated=new ClipperLib.Paths();
        coDil.Execute(dilated,neckR);
        var bridged=sol;
        if(dilated.length){
          var coEr=new ClipperLib.ClipperOffset(2,0.25*CS);
          coEr.AddPaths(dilated,JOIN,ClipperLib.EndType.etClosedPolygon);
          var closed=new ClipperLib.Paths();
          coEr.Execute(closed,-neckR);
          if(closed.length)bridged=closed;
        }
        /* Filter only positive-area (outer) paths and clean. Letters that
           are far apart from any neighbor stay as separate paths. */
        var finalPaths=[];
        for(var fi=0;fi<bridged.length;fi++){
          var area=ClipperLib.Clipper.Area(bridged[fi]);
          if(area<=0)continue;
          var cleaned=ClipperLib.Clipper.CleanPolygon(bridged[fi],0.5*CS);
          if(cleaned&&cleaned.length>=4)finalPaths.push(cleaned);
        }
        logCounts('smartBridge',finalPaths);
        if(!finalPaths.length){console.warn('[sl2-vector-text] smartBridge empty, falling back to union+offset');return pathsToOutput(sol);}
        return pathsToOutput(finalPaths);
      })
      .catch(function(e){console.warn('[sl2-vector-text] failed:',e);return null;});
  };
  /* Auto-replace text cutline with vector version after each render.
     DISABLED — too many edge cases (font mismatch between visible Fabric
     rendering and opentype-loaded binary, transform alignment, curve
     flattening artifacts produce jagged or shifted cutlines). The raster
     path in getContourFromTemplateElements is the active text cutline
     algorithm. _sl2GetTextPathContour stays exposed for manual testing
     but the hook below is no-op. Re-enable via
     window._sl2VectorTextEnabled = true */
  window._sl2VectorTextEnabled=false;
  function getCutOffsetFromState(){
    var st=window._sl2St;if(!st)return 20;
    var map={none:-2,tight:12,medium:25,loose:50};
    return map[st.cutStyle]||20;
  }
  var _vtPending=false,_vtLastSig='';
  function textSignature(c){
    var sig='';c.getObjects().forEach(function(o){
      if(o.type==='i-text'&&!o._isCutline){
        sig+='|'+o.text+'|'+o.fontFamily+'|'+o.fontSize+'|'+(o.left|0)+','+(o.top|0)+'|'+(o.scaleX||1).toFixed(2)+','+(o.scaleY||1).toFixed(2)+'|'+(o.angle||0).toFixed(1)+'|'+(o.textAlign||'left');
      }
    });
    return sig;
  }
  function trySwapVectorContour(){
    if(!window._sl2VectorTextEnabled||_vtPending)return;
    var st=window._sl2St;if(!st||!st.canvas||st.shape!=='die-cut')return;
    var c=st.canvas;
    /* Only run for text-only canvases (no images, has text). */
    var allObjs=c.getObjects().filter(function(o){return!o._isCutline&&!o._isScissorIcon;});
    var hasImg=allObjs.some(function(o){return o.type==='image';});
    var hasText=allObjs.some(function(o){return o.type==='i-text';});
    if(hasImg||!hasText)return;
    var sig=textSignature(c);
    if(sig===_vtLastSig)return;
    _vtLastSig=sig;_vtPending=true;
    var offsetPx=getCutOffsetFromState();
    window._sl2GetTextPathContour(c,offsetPx).then(function(r){
      _vtPending=false;
      if(!r||sig!==textSignature(c))return; /* stale */
      /* Replace cutline objects with the vector path. Find existing
         cutline fabric.Path objects and update their `path` data. */
      var cuts=c.getObjects().filter(function(o){return o._isCutline;});
      if(!cuts.length)return;
      cuts.forEach(function(p){
        if(p.set&&p._set){
          try{
            /* Rebuild the path data on each cutline object. fabric.Path
               supports re-parsing via the `path` property setter. */
            var newPathObj=new fabric.Path(r.offsetSvg);
            p.path=newPathObj.path;
            p.pathOffset=newPathObj.pathOffset;
            p.width=newPathObj.width;p.height=newPathObj.height;
            p.left=newPathObj.left;p.top=newPathObj.top;
            p.dirty=true;
          }catch(e){console.warn('[sl2-vector-text] swap failed:',e);}
        }
      });
      st.cutContourPath=r.offsetSvg;
      st.cutContourPoints=r.offsetPts;
      c.renderAll();
      if(window._sl2PositionOverlays)window._sl2PositionOverlays();
    }).catch(function(){_vtPending=false;});
  }
  /* Run on every Fabric render (debounced via signature check). */
  function attachHook(){
    var st=window._sl2St;if(!st||!st.canvas)return setTimeout(attachHook,500);
    st.canvas.on('after:render',function(){
      /* Schedule async to avoid recursion in render. */
      requestAnimationFrame(trySwapVectorContour);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',attachHook);
  else attachHook();
})();
/* Island bridging — connects detached artwork (sparkles, hearts, question
   marks) to the main shape via thin rectangle bridges. Bridges are only
   added between pairs that won't naturally merge from the subsequent
   ClipperOffset, but are within MAX_ISLAND_DISTANCE. Returns the unioned
   bP that the section then offsets. */
window._sl2BridgeIslands=function(aC,stickerWidth,offsetPx,CS){
  if(!aC||!aC.length||!window.ClipperLib)return aC;
  try{
    var IA=4*CS*CS;
    var MID=Math.max(40,(stickerWidth||300)*0.25)*CS;
    var BW=1*CS;
    var NM=offsetPx*2*CS;
    var kC=[];
    for(var z=0;z<aC.length;z++){
      if(Math.abs(ClipperLib.Clipper.Area(aC[z]))>=IA)kC.push(aC[z]);
    }
    var br=[];
    for(var ki=0;ki<kC.length;ki++)for(var kj=ki+1;kj<kC.length;kj++){
      var pA=kC[ki],pB=kC[kj],mD=Infinity,bA=null,bB=null;
      for(var a2=0;a2<pA.length;a2+=3)for(var b2=0;b2<pB.length;b2+=3){
        var dx=pA[a2].X-pB[b2].X,dy=pA[a2].Y-pB[b2].Y,d2=dx*dx+dy*dy;
        if(d2<mD){mD=d2;bA=pA[a2];bB=pB[b2];}
      }
      if(bA&&mD>NM*NM&&mD<MID*MID){
        var bx=bB.X-bA.X,by=bB.Y-bA.Y,bl=Math.sqrt(bx*bx+by*by);
        if(bl>0){
          var nx=-by/bl*(BW/2),ny=bx/bl*(BW/2);
          br.push([
            {X:Math.round(bA.X+nx),Y:Math.round(bA.Y+ny)},
            {X:Math.round(bB.X+nx),Y:Math.round(bB.Y+ny)},
            {X:Math.round(bB.X-nx),Y:Math.round(bB.Y-ny)},
            {X:Math.round(bA.X-nx),Y:Math.round(bA.Y-ny)}
          ]);
        }
      }
    }
    var aF=kC.concat(br);
    if(aF.length<=1)return aF;
    var uc=new ClipperLib.Clipper();
    for(var ci=0;ci<aF.length;ci++)uc.AddPath(aF[ci],ClipperLib.PolyType.ptSubject,true);
    var ul=new ClipperLib.Paths();
    uc.Execute(ClipperLib.ClipType.ctUnion,ul,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
    return ul.length?ul:aF;
  }catch(e){console.warn('[sl2-bridge]',e);return aC;}
};
/* Quantity rules: sizes under 8" need 50+ (2/4/10 grey out); sizes 8" and up
   can't order 50+ (50 and above grey out). Size = longest side.
   One-directional on purpose: sizes are never locked. Locking both axes made
   some valid combos unreachable (e.g. 2"@50 -> 8"@10 had every path greyed).
   Lives here because the section is at Shopify's 256 KB template limit. */
window._smsMOR=(function(){
  var TH=8,CAP=50,SMALL_QTY=10;
  (function(){var s=document.createElement('style');s.textContent=
    '.sl2-pill.sms-locked,.sms-qty-pre.sms-locked{background:#eeeef1!important;border-color:#e3e3e8!important;color:#b0b0b8!important;box-shadow:none!important;transform:none!important;cursor:not-allowed;pointer-events:none}'+
    '.sms-min-qty-hint{font-size:11px;color:#c8721c;background:rgba(245,158,11,.08);border:1px solid rgba(245,158,11,.18);padding:6px 10px;border-radius:8px;margin-top:12px!important;line-height:1.35;display:none}'+
    '.sms-min-qty-hint.visible{display:block}';
    (document.head||document.documentElement).appendChild(s);})();
  function q(sel){return document.querySelectorAll(sel);}
  function small(inch){return inch>0&&inch<TH;}
  function invalid(inch,qty){return (small(inch)&&qty<CAP)||(inch>=TH&&qty>=CAP);}
  function msg(inch){return small(inch)?'Sizes under 8″ require a minimum of 50 stickers.':'Sizes 8″ and up are limited to 10 stickers per order.';}
  function refresh(inch,qty){
    q('.sl2-pill[data-qty],.sms-qty-pre[data-qty]').forEach(function(p){p.classList.toggle('sms-locked',invalid(inch,parseInt(p.dataset.qty,10)||0));});
    var sl=document.getElementById('qtySlider');
    if(sl){var mn=small(inch)?CAP:10,mx=inch>=TH?SMALL_QTY:500,v=parseInt(sl.value,10)||0;sl.min=mn;sl.max=mx;if(v<mn)sl.value=mn;else if(v>mx)sl.value=mx;}
    var on=inch>0,t=msg(inch);
    q('.sms-min-qty-hint').forEach(function(h){if(on)h.textContent=t;h.classList.toggle('visible',on);});
  }
  /* Size always wins: if the current qty isn't allowed at this size, move qty to
     the nearest allowed value (50 for small sizes, 10 for 8" and up). */
  function bump(st,by,spec){
    if(!invalid(st.sizeInches,st.qty))return false;
    var t=small(st.sizeInches)?CAP:SMALL_QTY;
    st.qty=t;
    var v=document.getElementById('qtyVal');if(v)v.value=t;
    var s=document.getElementById('qtySlider');if(s)s.value=t;
    q('.sms-qty-pre,.sl2-pill[data-qty]').forEach(function(b){b.classList.toggle('active',parseInt(b.dataset.qty,10)===t);});
    if(spec)spec.qty=t;
    return true;
  }
  return {invalid:invalid,msg:msg,refresh:refresh,bump:bump};
})();
/* Cut path smoothing helpers — extracted from section for size budget */
window._sl2ClosePass=function(sol){return sol;};
/* Text halo contour generator — extracted to free section bytes.
   Renders all i-text objects on a temp canvas, builds a mask, dilates &
   smooths, traces, unions, offsets, and runs a close pass to fill inter-
   letter notches. Helpers (dilateMask, smoothMask, mooreTrace, rdpR,
   ptsToSmoothSvg) are passed in from the section since they live there. */
window._sl2GetTextHaloContour=function(c,offsetPx,h,opts){
  opts=opts||{};
  /* dilation controls how aggressively to inflate the text mask before tracing.
     18 = default (for image+text scenarios where text needs to "halo" outward
     and merge with the image cutline). For pure-text canvases, this over-inflates
     the cutline so the caller should pass a lower value (e.g., 6) to make the
     cutline hug the glyphs at offsetPx instead of offsetPx + ~12 canvas units. */
  var DIL=typeof opts.dilation==='number'?opts.dilation:18;
  /* closeR controls the Clipper close-gaps radius (offset out then in). Default 60
     bridges word-level gaps so the final cutline is one continuous shape. Pass 0
     to disable, or a smaller value to allow inter-word breaks. */
  var CLOSE_R=typeof opts.closeRadius==='number'?opts.closeRadius:60;
  var tO=c.getObjects().filter(function(o){return o.type==='i-text'&&!o._isCutline&&!o._isScissorIcon;});
  if(!tO.length) return null;
  var hd=[],oB=c.backgroundColor;
  try{
    c.getObjects().forEach(function(o){if(tO.indexOf(o)<0&&o.visible!==false){o.visible=false;hd.push(o);}});
    c.backgroundColor=null;
    var cw=c.width,ch=c.height,p0=100,ml=0,mt=0,mr=cw,mb=ch;
    tO.forEach(function(o){o.setCoords();var b=o.getBoundingRect();ml=Math.min(ml,b.left-p0);mt=Math.min(mt,b.top-p0);mr=Math.max(mr,b.left+b.width+p0);mb=Math.max(mb,b.top+b.height+p0);});
    var eL=Math.round(-Math.min(0,ml)),eT=Math.round(-Math.min(0,mt)),eW=Math.round(Math.max(cw,mr-ml)),eH=Math.round(Math.max(ch,mb-mt)),ex=eL>0||eT>0||eW>cw||eH>ch;
    if(ex){tO.forEach(function(o){o.set({left:o.left+eL,top:o.top+eT});o.setCoords();});c.setWidth(eW);c.setHeight(eH);}
    var oVT=c.viewportTransform.slice();c.viewportTransform=[1,0,0,1,0,0];
    var tc=c.toCanvasElement(1.5),ew=tc.width,eh=tc.height,cx=tc.getContext('2d');
    c.viewportTransform=oVT;
    if(ex){tO.forEach(function(o){o.set({left:o.left-eL,top:o.top-eT});o.setCoords();});c.setWidth(cw);c.setHeight(ch);}
    hd.forEach(function(o){o.visible=true;});hd=[];c.backgroundColor=oB;c.renderAll();
    var d=cx.getImageData(0,0,ew,eh).data,mk=new Uint8Array(ew*eh),mc=0;
    for(var i=0;i<ew*eh;i++)if(d[i*4+3]>30){mk[i]=1;mc++;}
    if(!mc) return null;
    var dl=DIL>0?h.dilateMask(mk,ew,eh,DIL):new Uint8Array(mk);for(var i=0;i<4;i++)h.smoothMask(dl,ew,eh);
    var bg=new Uint8Array(ew*eh),hq=[];
    for(var x=0;x<ew;x++){if(!dl[x]){bg[x]=1;hq.push(x);}if(!dl[(eh-1)*ew+x]){bg[(eh-1)*ew+x]=1;hq.push((eh-1)*ew+x);}}
    for(var y=1;y<eh-1;y++){if(!dl[y*ew]){bg[y*ew]=1;hq.push(y*ew);}if(!dl[y*ew+ew-1]){bg[y*ew+ew-1]=1;hq.push(y*ew+ew-1);}}
    while(hq.length){var hi=hq.pop(),hx=hi%ew,hy=(hi-hx)/ew;for(var dy=-1;dy<=1;dy++)for(var dx=-1;dx<=1;dx++){var nx=hx+dx,ny=hy+dy;if(nx>=0&&nx<ew&&ny>=0&&ny<eh){var ni=ny*ew+nx;if(!dl[ni]&&!bg[ni]){bg[ni]=1;hq.push(ni);}}}}
    for(var i=0;i<ew*eh;i++)if(!dl[i]&&!bg[i])dl[i]=1;
    var rcw=ex?eW:cw,rch=ex?eH:ch,sX=rcw/ew,sY=rch/eh,shBx=ex?eL:0,shBy=ex?eT:0,CS=5000,aC=[],tM=new Uint8Array(dl.length);
    for(var i=0;i<dl.length;i++) tM[i]=dl[i];
    for(var p=0;p<20;p++){
      var rw=h.mooreTrace(tM,ew,eh);if(rw.length<10) break;
      var sp=h.rdpR(rw,0.8);
      if(sp.length>=4) aC.push(sp.map(function(pt){return{X:Math.round((pt[0]*sX-shBx)*CS),Y:Math.round((pt[1]*sY-shBy)*CS)};}));
      var b0=rw[0][1]*ew+rw[0][0];
      if(b0>=0&&b0<ew*eh){var fq=[b0];tM[b0]=0;while(fq.length){var fi=fq.pop(),fx=fi%ew,fy=(fi-fx)/ew;for(var fdy=-1;fdy<=1;fdy++)for(var fdx=-1;fdx<=1;fdx++){var fnx=fx+fdx,fny=fy+fdy;if(fnx>=0&&fnx<ew&&fny>=0&&fny<eh){var fni=fny*ew+fnx;if(tM[fni]){tM[fni]=0;fq.push(fni);}}}}}
    }
    if(!aC.length) return null;
    var bP;
    if(aC.length===1){bP=aC;}
    else{var uc=new ClipperLib.Clipper();for(var ci=0;ci<aC.length;ci++)uc.AddPath(aC[ci],ClipperLib.PolyType.ptSubject,true);var ul=new ClipperLib.Paths();uc.Execute(ClipperLib.ClipType.ctUnion,ul,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);bP=ul.length?ul:aC;}
    var co=new ClipperLib.ClipperOffset();co.ArcTolerance=0.05*CS;
    for(var bi=0;bi<bP.length;bi++) co.AddPath(bP[bi],ClipperLib.JoinType.jtRound,ClipperLib.EndType.etClosedPolygon);
    var sol=new ClipperLib.Paths();co.Execute(sol,offsetPx*CS);
    if(!sol.length) return null;
    var _txClR=CLOSE_R*CS;
    if(_txClR>0&&sol.length){var _txCo1=new ClipperLib.ClipperOffset();_txCo1.ArcTolerance=0.05*CS;for(var _txi=0;_txi<sol.length;_txi++)_txCo1.AddPath(sol[_txi],ClipperLib.JoinType.jtRound,ClipperLib.EndType.etClosedPolygon);var _txExp=new ClipperLib.Paths();_txCo1.Execute(_txExp,_txClR);if(_txExp.length){var _txCo2=new ClipperLib.ClipperOffset();_txCo2.ArcTolerance=0.05*CS;for(var _txi=0;_txi<_txExp.length;_txi++)_txCo2.AddPath(_txExp[_txi],ClipperLib.JoinType.jtRound,ClipperLib.EndType.etClosedPolygon);var _txClosed=new ClipperLib.Paths();_txCo2.Execute(_txClosed,-_txClR);if(_txClosed.length)sol=_txClosed;}}
    var aS=[],aP=[];
    for(var si=0;si<sol.length;si++){var oR=sol[si].map(function(pt){return[pt.X/CS,pt.Y/CS];});var oS=h.rdpR(oR,Math.max(0.2,offsetPx*0.05));var s=h.ptsToSmoothSvg(oS);if(s){aS.push(s);aP.push(oS);}}
    if(!aS.length) return null;
    return {offsetSvg:aS.join(' '),offsetPts:aP[0],allOffsetPts:aP};
  }catch(e){hd.forEach(function(o){o.visible=true;});c.backgroundColor=oB;c.renderAll();return null;}
};
window._sl2MidSvg=function(pts){
  if(!pts||pts.length<3)return null;
  var n=pts.length,m0x=(pts[0][0]+pts[1][0])/2,m0y=(pts[0][1]+pts[1][1])/2,p='M '+m0x+' '+m0y;
  for(var qi=1;qi<=n;qi++){var v=pts[qi%n],nx=pts[(qi+1)%n];p+=' Q '+v[0]+' '+v[1]+' '+((v[0]+nx[0])/2)+' '+((v[1]+nx[1])/2);}
  return p+' Z';
};
window._sl2SelectiveSmooth=function(pts,thresh,blend){
  if(!pts||pts.length<4)return pts;
  thresh=thresh==null?0.85:thresh;blend=blend==null?0.4:blend;
  var n=pts.length,out=pts.map(function(p){return[p[0],p[1]];});
  for(var i=0;i<n;i++){
    var pv=pts[(i-1+n)%n],cv=pts[i],nx=pts[(i+1)%n];
    var v1x=cv[0]-pv[0],v1y=cv[1]-pv[1],v2x=nx[0]-cv[0],v2y=nx[1]-cv[1];
    var l1=Math.sqrt(v1x*v1x+v1y*v1y),l2=Math.sqrt(v2x*v2x+v2y*v2y);
    if(l1<0.01||l2<0.01)continue;
    var cosA=(v1x*v2x+v1y*v2y)/(l1*l2);
    if(cosA<thresh){
      var mx=(pv[0]+nx[0])/2,my=(pv[1]+nx[1])/2;
      out[i]=[cv[0]*(1-blend)+mx*blend,cv[1]*(1-blend)+my*blend];
    }
  }
  return out;
};
/* Snap near-collinear vertices onto their chord. Targets staircase-of-pixels jiggle
   in raster traces (e.g. icon PNG edges) that would otherwise be amplified by the
   midpoint-quadratic bezier into wavy "warped" outlines. Threshold = max perpendicular
   distance (in image pixels) at which a vertex still counts as "on the line". */
window._sl2StraightenRuns=function(pts,thresh){
  if(!pts||pts.length<4)return pts;
  thresh=thresh==null?0.7:thresh;
  var n=pts.length,out=pts.map(function(p){return[p[0],p[1]];});
  for(var i=0;i<n;i++){
    var pv=pts[(i-1+n)%n],cv=pts[i],nx=pts[(i+1)%n];
    var dx=nx[0]-pv[0],dy=nx[1]-pv[1],len2=dx*dx+dy*dy;
    if(len2<0.0001)continue;
    var t=((cv[0]-pv[0])*dx+(cv[1]-pv[1])*dy)/len2;
    var px=pv[0]+t*dx,py=pv[1]+t*dy;
    var ex=cv[0]-px,ey=cv[1]-py;
    if(Math.sqrt(ex*ex+ey*ey)<thresh)out[i]=[px,py];
  }
  return out;
};
/* Morphological close (dilate by R, then erode by R). Bridges concavities and gaps
   smaller than 2R without expanding the overall shape. Scaled to border thickness in
   the cutline pipeline so small borders preserve per-letter contour while large
   borders fuse adjacent letters into a smooth slab — matching the design principle
   that close cutlines should hug detail and far cutlines should be smooth blobs. */
window._sl2MorphClose=function(mask,w,h,r,dilFn,fillFn){
  if(!r||r<=0)return new Uint8Array(mask);
  var n=w*h,dilC=dilFn(mask,w,h,r);
  if(fillFn)fillFn(dilC,w,h);
  var inv=new Uint8Array(n);for(var i=0;i<n;i++)inv[i]=dilC[i]?0:1;
  var invD=dilFn(inv,w,h,r);
  var out=new Uint8Array(n);for(var i=0;i<n;i++)out[i]=invD[i]?0:1;
  if(fillFn)fillFn(out,w,h);
  return out;
};
/* Flatten long axial runs at bbox edges. Detects sequences of consecutive
   vertices clustered near bbox top/bottom/left/right and snaps them to the exact
   edge. Only fires when the run spans a significant fraction of the bbox so it
   catches text baselines (50+ flat points across letters) without disturbing
   curves (only a handful of points near a circle's apex). Fixes the wavy
   cutline below text caused by per-letter offset arcs creating scallops where
   adjacent letter offsets meet at a shared baseline. */
window._sl2FlattenAxialRuns=function(pts,minSpanRatio){
  if(!pts||pts.length<8)return pts;
  minSpanRatio=minSpanRatio==null?0.35:minSpanRatio;
  var n=pts.length,mnX=Infinity,mnY=Infinity,mxX=-Infinity,mxY=-Infinity;
  for(var i=0;i<n;i++){var p=pts[i];if(p[0]<mnX)mnX=p[0];if(p[0]>mxX)mxX=p[0];if(p[1]<mnY)mnY=p[1];if(p[1]>mxY)mxY=p[1];}
  var W=mxX-mnX,H=mxY-mnY;if(W<10||H<10)return pts;
  var EPS=Math.max(1.5,Math.min(W,H)*0.012);
  var out=pts.map(function(p){return[p[0],p[1]];});
  function applyEdge(axis,target,coord,minSpan){
    /* axis 0=x,1=y; target=value to snap to; coord 0/1=which axis to span */
    var bestS=-1,bestL=0,cs=-1,cl=0,seen=0;
    for(var i=0;i<n*2&&seen<n+bestL;i++){
      var idx=i%n,p=pts[idx],near=axis===1?(target===mxY?p[1]>mxY-EPS:p[1]<mnY+EPS):(target===mxX?p[0]>mxX-EPS:p[0]<mnX+EPS);
      if(near){if(cs<0)cs=idx;cl++;}else{if(cl>bestL){bestL=cl;bestS=cs;}cs=-1;cl=0;}
      seen++;
    }
    if(cl>bestL){bestL=cl;bestS=cs;}
    if(bestS<0||bestL<3)return;
    var smn=Infinity,smx=-Infinity;
    for(var i=0;i<bestL;i++){var v=pts[(bestS+i)%n][coord];if(v<smn)smn=v;if(v>smx)smx=v;}
    if((smx-smn)<minSpan)return;
    for(var i=0;i<bestL;i++)out[(bestS+i)%n][axis]=target;
  }
  applyEdge(1,mxY,0,W*minSpanRatio); /* bottom */
  applyEdge(1,mnY,0,W*minSpanRatio); /* top */
  applyEdge(0,mxX,1,H*minSpanRatio); /* right */
  applyEdge(0,mnX,1,H*minSpanRatio); /* left */
  return out;
};
window._sl2DenseSamp=function(pts,steps){
  if(!pts||pts.length<3)return pts;
  steps=steps||24;
  var n=pts.length,out=[];
  for(var i=0;i<n;i++){
    var v=pts[i],nx=pts[(i+1)%n],pv=pts[(i-1+n)%n];
    var m0x=(pv[0]+v[0])/2,m0y=(pv[1]+v[1])/2,m1x=(v[0]+nx[0])/2,m1y=(v[1]+nx[1])/2;
    for(var s=0;s<steps;s++){
      var t=s/steps,omt=1-t;
      out.push([omt*omt*m0x+2*omt*t*v[0]+t*t*m1x,omt*omt*m0y+2*omt*t*v[1]+t*t*m1y]);
    }
  }
  return out;
};
window._sl2EmitBezPDF=function(bezPath,lipBnds,tPtW,tPtH,bPt,ptH,PDFOperator,PDFNumber){
  if(!bezPath||bezPath.indexOf(' Q ')<0)return null;
  var ops=[],toks=bezPath.trim().split(/\s+/),ti=0,prev=null;
  var mp=function(x,y){return[parseFloat(((x-lipBnds.left)*(tPtW/lipBnds.width)+bPt).toFixed(3)),parseFloat((ptH-((y-lipBnds.top)*(tPtH/lipBnds.height))-bPt).toFixed(3))];};
  while(ti<toks.length){var tk=toks[ti];
    if(tk==='M'){if(ops.length)ops.push(PDFOperator.of('h'));var pt=mp(parseFloat(toks[ti+1]),parseFloat(toks[ti+2]));ops.push(PDFOperator.of('m',[PDFNumber.of(pt[0]),PDFNumber.of(pt[1])]));prev=pt;ti+=3;}
    else if(tk==='Q'){var v=mp(parseFloat(toks[ti+1]),parseFloat(toks[ti+2])),e=mp(parseFloat(toks[ti+3]),parseFloat(toks[ti+4]));var c1x=(prev[0]+2*v[0])/3,c1y=(prev[1]+2*v[1])/3,c2x=(e[0]+2*v[0])/3,c2y=(e[1]+2*v[1])/3;ops.push(PDFOperator.of('c',[PDFNumber.of(parseFloat(c1x.toFixed(3))),PDFNumber.of(parseFloat(c1y.toFixed(3))),PDFNumber.of(parseFloat(c2x.toFixed(3))),PDFNumber.of(parseFloat(c2y.toFixed(3))),PDFNumber.of(e[0]),PDFNumber.of(e[1])]));prev=e;ti+=5;}
    else ti++;
  }
  return ops;
};

/* Local cart drawer for mobile toolbar */
(function(){
  window._sl2Cart=function(){
    if(!window._sl2Hcc||!window._sl2Hcc())return;
    var s=window._specS||{size:'2x2',sizeInches:2,finish:'matte',qty:50};
    var p=window.DTF?DTF.price():(window._sl2Price?window._sl2Price(s.sizeInches,s.finish,s.qty):{total:0,unit:0});
    var cv=window._sl2St&&window._sl2St.canvas;
    var th=cv?cv.toDataURL(window.DTF?{format:'png',multiplier:.3}:{format:'jpeg',quality:.5,multiplier:.3}):'';
    var old=document.getElementById('sl2-lc');if(old)old.remove();
    var d=document.createElement('div');d.id='sl2-lc';d.className='sms sl2-lc-wrap';
    d.innerHTML='<div class="sl2-lc-box">'
      +'<div class="sl2-lc-hd"><span class="sl2-lc-ht">'+(window.DTF?'Your gang sheet':'Your Sticker')+'</span>'
      +'<button id="sl2-lcx" class="sl2-lc-xb">&times;</button></div>'
      +'<div class="sl2-lc-row">'+(th?'<img src="'+th+'" class="sl2-lc-img">':'')
      +'<div class="sl2-lc-info"><b>'+(window.DTF?'DTF gang sheet':'Custom Sticker')+'</b>'
      +'<p class="sl2-lc-sub">'+(window.DTF?DTF.pillText():s.size+' &bull; '+s.finish+' &bull; '+s.qty+' stickers')+'</p>'
      +'<b class="sl2-lc-pr">$'+p.total.toFixed(2)+'</b></div></div>'
      +(function(){if(!window.DTF||!DTF.issues)return '';var c=(DTF.issues()||{}).count||{},n=function(k){var v=c[k];return v?(v.length!=null?v.length:+v||0):0;},t=[];if(n('overlap'))t.push(n('overlap')+' overlapping');if(n('off'))t.push(n('off')+' past the sheet edge');if(n('edge'))t.push(n('edge')+' in the unprintable edge');return t.length?'<div class="sl2-lc-warn" style="display:flex;gap:10px;align-items:center;margin:0 0 12px;padding:10px 12px;border-radius:10px;background:#fff4e5;color:#8a4b00;font-size:12.5px;line-height:1.35;">'+'<span style="flex:1;">Designs would print wrong: '+t.join(', ')+'.</span>'+'<button type="button" id="sl2-lcn" style="flex:none;padding:8px 11px;border:none;border-radius:8px;background:#8a4b00;color:#fff;font-size:12px;font-weight:700;cursor:pointer;">Auto-nest</button></div>':'';})()
      +'<button id="sl2-lco" class="sl2-lc-co">ADD TO CART</button>'
      +'<button id="sl2-lcc" class="sl2-lc-ct">Continue designing</button></div>';
    document.body.appendChild(d);
    function _r(){d.remove();}
    var q=function(sel){return d.querySelector(sel);};
    q('#sl2-lcx').onclick=q('#sl2-lcc').onclick=_r;
    var _lcn=q('#sl2-lcn');if(_lcn)_lcn.onclick=function(ev){if(ev)ev.stopPropagation();_r();DTF.autoNest();};
    d.addEventListener('click',function(e){if(e.target===d)_r();});
    q('#sl2-lco').onclick=function(ev){
      /* Stop propagation so the backdrop handler on `d` never sees this click */
      if(ev)ev.stopPropagation();
      /* Close the drawer intentionally */
      _r();
      /* Remove any stale overlay */
      var stale=document.getElementById('sl2-co-ol');if(stale)stale.remove();
      /* Hidden button — proof modal handles all visible UI; this is just for
         doAddToCart to track _apPr flag and write spinner text into. No visible
         dark fullscreen overlay anymore (was creating a redundant popup behind
         the proof modal on mobile). */
      var coBtn=document.createElement('button');
      coBtn.id='sl2-co-ol';
      coBtn.style.cssText='position:fixed;left:-9999px;top:-9999px;width:1px;height:1px;opacity:0;pointer-events:none;';
      document.body.appendChild(coBtn);
      window._sl2Co=1;
      if(window._doATC){
        window._doATC(coBtn);
      }
    };
  };
})();

/* ── Mobile 3D tilt — full override ──────────────────────────────────────────
   Problem: the liquid's toggle3D calls requestPermission() AFTER setting the
   button blue. If permission was denied (previous session), the promise
   resolves as a microtask before the browser paints, resetting the color.
   User sees "does nothing."

   Fix: use a capture-phase touchstart listener (fires before the liquid's
   bubble-phase one) with stopImmediatePropagation, implement the correct
   flow where we request permission FIRST, then set the blue state only
   if it is granted.  Also use the liquid's gyro infrastructure
   (_sl2HandleGyro, _sl2RestartGyro) when available for full vinyl effects.
   ─────────────────────────────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function(){
  var btn = document.getElementById('sl2Tb3D');
  if(!btn) return;

  /* ---- simplified fallback gyro (used only when liquid's setup3DTilt
          didn't run, i.e. _sl2RestartGyro is not set) -------------------- */
  var _fbActive=false, _fbRawB=0, _fbRawG=0, _fbGB=0, _fbGG=0;
  function _fbApply(nx,ny){
    var s=document.getElementById('stickerStage');
    if(!s) return;
    var zl=window._sl2ZoomLevel||1;
    s.style.transform='scale('+zl+') rotateX('+(-ny*15)+'deg) rotateY('+(nx*15)+'deg)';
  }
  function _fbLoop(){
    if(!_fbActive||!window._sl2GyroActive) return;
    /* Suppress tilt while any tool has marked state.adjusting=true (lock/adjust/crop modes).
       Previously checked window._sms which is never assigned — bug, tilt always applied. */
    var st=window._sl2St;
    if(!(st&&st.adjusting)){
      _fbGB+=(_fbRawB-_fbGB)*0.12; _fbGG+=(_fbRawG-_fbGG)*0.12;
      _fbApply(Math.max(-1,Math.min(1,_fbGG/30)),Math.max(-1,Math.min(1,_fbGB/30)));
    }
    requestAnimationFrame(_fbLoop);
  }
  function _fbHandleGyro(e){
    if(e.beta==null&&e.gamma==null) return;
    _fbRawB=Math.max(-30,Math.min(30,(e.beta||0)-75));
    _fbRawG=Math.max(-30,Math.min(30,e.gamma||0));
    if(!_fbActive){_fbActive=true; requestAnimationFrame(_fbLoop);}
  }
  function _fbRestart(){if(!_fbActive)_fbActive=true; requestAnimationFrame(_fbLoop);}

  /* ---- resolve which gyro functions to use ----------------------------- */
  function getGyroHandler(){ return window._sl2HandleGyro||_fbHandleGyro; }
  function restartGyro(){
    if(window._sl2RestartGyro) window._sl2RestartGyro();
    else _fbRestart();
  }

  /* ---- core toggle3D logic (iOS-safe: don't go blue until granted) ----- */
  function toggle3D(){
    var svg=btn.querySelector('svg');
    if(window._sl2GyroActive){
      /* turn OFF */
      window._sl2GyroActive=false; _fbActive=false;
      btn.style.color=''; if(svg)svg.style.stroke='';
      var s=document.getElementById('stickerStage');
      if(s){var zl=window._sl2ZoomLevel||1; s.style.transform='scale('+zl+') rotateX(0) rotateY(0)';}
    } else {
      /* turn ON */
      if(typeof DeviceOrientationEvent!=='undefined'&&
         typeof DeviceOrientationEvent.requestPermission==='function'){
        /* iOS: request FIRST — go blue only on grant, never on deny */
        DeviceOrientationEvent.requestPermission().then(function(p){
          if(p==='granted'){
            window._sl2GyroActive=true;
            btn.style.color='#2893F2'; if(svg)svg.style.stroke='#2893F2';
            window.addEventListener('deviceorientation',getGyroHandler(),true);
            restartGyro();
          } else {
            /* denied — show brief feedback, leave button unlit */
            btn.style.color='#ef4444'; if(svg)svg.style.stroke='#ef4444';
            setTimeout(function(){btn.style.color='';if(svg)svg.style.stroke='';},1800);
          }
        }).catch(function(){
          btn.style.color='#ef4444'; if(svg)svg.style.stroke='#ef4444';
          setTimeout(function(){btn.style.color='';if(svg)svg.style.stroke='';},1800);
        });
      } else {
        /* Android / no-permission path — go blue immediately */
        window._sl2GyroActive=true;
        btn.style.color='#2893F2'; if(svg)svg.style.stroke='#2893F2';
        window.addEventListener('deviceorientation',getGyroHandler(),true);
        restartGyro();
      }
    }
  }
  window._sl2Toggle3D=toggle3D;

  /* ---- click-only handler: iOS 13+ requires a click (not touchstart with
          preventDefault) for DeviceOrientationEvent.requestPermission to be
          treated as a valid user gesture. stopPropagation prevents the
          liquid's bubble-phase delegation from double-triggering. ---------- */
  btn.addEventListener('click',function(e){
    e.stopPropagation();
    toggle3D();
  });
});

/* SVG rasterizer — upscales small/viewBox-only SVGs to proper pixel dimensions */
(function(){
  window._rasterSvg = function(img, cb) {
    var w = img.naturalWidth || img.width;
    var h = img.naturalHeight || img.height;
    if (w < 10 || h < 10) { w = 1200; h = 1200; }
    else if (w < 400 || h < 400) {
      var u = Math.max(1200 / w, 1200 / h);
      w = Math.round(w * u);
      h = Math.round(h * u);
    }
    var cv = document.createElement('canvas');
    cv.width = w; cv.height = h;
    cv.getContext('2d').drawImage(img, 0, 0, w, h);
    var r = new Image();
    r.onload = function() { cb(r); };
    r.src = cv.toDataURL('image/png');
  };
})();

/* ══════════ PROOF APPROVAL MODAL ══════════
   Called before ATC fires. Renders a realistic preview with shadow,
   specs tile, quality warnings, and requires explicit checkbox approval. */
(function(){
  window._sl2Proof=async function(onApprove){
    var st=window._sl2St;
    if(!st||!window._sl2Cap){if(onApprove)onApprove();return;}
    var old=document.getElementById('sl2-proof-ol');if(old)old.remove();
    /* Generate proof preview (reuses capturePreview → PNG bytes) */
    var bytes=await window._sl2Cap();
    if(document.getElementById('sl2-proof-ol'))return;
    if(!bytes){if(onApprove)onApprove();return;}
    var blob=new Blob([bytes],{type:'image/png'});
    var url=URL.createObjectURL(blob);
    /* DPI quality check — iterates all image overlays, computes effective DPI
       per image based on its printed size on the sticker, reports the worst.
       Templates have a blank _isTemplateBg main image that must be ignored. */
    var dpiWarn='',dpi=0,worst=Infinity;
    if(st.canvas){
      var cw=st.canvas.getWidth(),ch=st.canvas.getHeight(),_smnLb=window.SMN&&SMN.lip&&SMN.lip(),maxDim=_smnLb&&_smnLb.width?Math.max(_smnLb.width,_smnLb.height):Math.max(cw,ch);
      var inchPerCU=(st.sizeInches||2)/maxDim;
      st.canvas.getObjects('image').forEach(function(o){
        if(o._isCutline||o._isScissorIcon||o._isTemplateBg||o.visible===false)return;
        var el=o.getElement&&o.getElement();if(!el)return;
        var nw=el.naturalWidth||el.width;if(!nw)return;
        var dW=(o.width||nw)*(o.scaleX||1),printedIn=dW*inchPerCU;
        if(printedIn>0.25){
          var d=nw/printedIn;
          if(d<worst)worst=d;
        }
      });
    }
    if(window.DTF){worst=DTF.worstDpiAll?await DTF.worstDpiAll():DTF.worstDpi();if(document.getElementById('sl2-proof-ol'))return;}
    if(worst!==Infinity)dpi=Math.round(worst);
    var _dtfLo=window.DTF?200:100,_dtfMid=window.DTF?250:150;
    if(dpi&&dpi<_dtfMid){
      var isBad=dpi<_dtfLo,cls=isBad?'sl2-pw-err':'';
      dpiWarn='<div class="sl2-proof-warn '+cls+'"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg><div><b>'+(isBad?'Low resolution':'Moderate resolution')+':</b> '+dpi+' DPI '+(isBad?'\u2014 print may appear blurry. Try a larger source image'+(window.DTF?' or print it smaller (the Check panel shows which).':'.'):'\u2014 should print fine. 300 DPI is ideal.')+'</div></div>';
    }
    /* Multi-cut HARD BLOCK — design has multiple disconnected cut paths in
       die-cut mode (would cut as separate stickers, which we don't support).
       Force user to fix the design before they can checkout. */
    var multiWarn='';
    var cutPath=st.cutContourPath||'';
    var mCount=(cutPath.match(/M /g)||[]).length;
    var blocked=st.shape==='die-cut'&&mCount>=2;if(st.shape==='dtf')st.cutContourPoints=null;
    if(blocked){
      multiWarn='<div class="sl2-proof-warn sl2-pw-err"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg><div><b>Can\u2019t proceed:</b> Your design has '+mCount+' separate cut shapes. Stickers must be a single piece. <b>Go back and increase Border size to Medium or Large</b> to merge them into one sticker.</div></div>';
    }
    /* Price + specs */
    var pc=window._sl2Price?window._sl2Price(st.sizeInches,st.finish,st.qty):{total:0};
    var sizeLabel=st.size==='custom'?(st.sizeInches+'"'):(st.size+'"');
    /* Build modal */
    var ol=document.createElement('div');
    ol.id='sl2-proof-ol';ol.className='sms sl2-proof-ol';
    ol.innerHTML='<div class="sl2-proof">'
      +'<div class="sl2-proof-hd">'
      +'<h3 class="sl2-proof-ht">Approve your proof</h3>'
      +'<button class="sl2-proof-x" aria-label="Close">\u00D7</button>'
      +'</div>'
      +'<div class="sl2-proof-body">'
      +'<div class="sl2-proof-stage">'
      +'<div class="sl2-proof-img-wrap finish-'+st.finish+'" style="--sl2-mask:url('+url+');">'
      +'<div class="sl2-proof-finish-bg"></div>'
      +'<img class="sl2-proof-img" src="'+url+'" alt="Proof preview">'
      +'<div class="sl2-proof-finish-ovr"></div>'
      +(function(pts){
        if(!pts||pts.length<3)return '';
        var mnX=1/0,mnY=1/0,mxX=-1/0,mxY=-1/0;
        for(var i=0;i<pts.length;i++){var p=pts[i];if(p[0]<mnX)mnX=p[0];if(p[0]>mxX)mxX=p[0];if(p[1]<mnY)mnY=p[1];if(p[1]>mxY)mxY=p[1];}
        var bw=mxX-mnX,bh=mxY-mnY;if(bw<=0||bh<=0)return '';
        var vw=1000,vh=Math.round(bh*1000/bw);
        var d='';
        for(var i=0;i<pts.length;i++){var x=((pts[i][0]-mnX)/bw*vw).toFixed(1),y=((pts[i][1]-mnY)/bh*vh).toFixed(1);d+=(i===0?'M ':' L ')+x+' '+y;}
        d+=' Z';
        var sI=0,sm=1/0;for(var i=0;i<pts.length;i++)if(pts[i][1]<sm){sm=pts[i][1];sI=i;}
        var scX=((pts[sI][0]-mnX)/bw*vw).toFixed(1),scY=((pts[sI][1]-mnY)/bh*vh).toFixed(1);
        return '<svg class="sl2-proof-cut" viewBox="0 0 '+vw+' '+vh+'" preserveAspectRatio="xMidYMid meet">'
          +'<path d="'+d+'" fill="none" stroke="#111" stroke-dasharray="5 3" stroke-linejoin="round" stroke-linecap="round" vector-effect="non-scaling-stroke" stroke-width="1"/>'
          +'<g transform="translate('+scX+' '+scY+') translate(-22 -22) scale(1.8)" stroke="#111" stroke-width="1.5" fill="white" stroke-linecap="round" stroke-linejoin="round">'
          +'<circle cx="6" cy="6" r="3"/><circle cx="6" cy="20" r="3"/>'
          +'<line x1="20" y1="4" x2="8.12" y2="15.88"/><line x1="14.47" y1="14.48" x2="20" y2="20"/><line x1="8.12" y1="8.12" x2="12" y2="12"/>'
          +'</g></svg>';
      })(st.cutContourPoints)
      +'</div>'
      +'</div>'
      +dpiWarn
      +multiWarn
      +'<div class="sl2-proof-specs">'
      +'<div class="sl2-proof-spec-row">'
      +(window.DTF?DTF.proofChips():'')
      +'</div>'
      +'<span class="sl2-proof-price">$'+pc.total.toFixed(2)+'</span>'
      +'</div>'
      +(blocked?'':'<label class="sl2-proof-ack"><input type="checkbox" id="sl2-proof-ack-cb"><span>I approve this design and confirm I have rights to print it.</span></label>')
      +'</div>'
      +'<div class="sl2-proof-ft">'
      +'<button class="sl2-proof-back'+(blocked?' sl2-proof-back-cta':'')+'">\u2190 '+(blocked?'Back to fix design':'Back to editor')+'</button>'
      +(blocked?'':'<button class="sl2-proof-ok" disabled>Approve &amp; Add to Cart</button>')
      +'</div>'
      +'</div>';
    document.body.appendChild(ol);
    function closeM(){URL.revokeObjectURL(url);ol.remove();}
    ol.querySelector('.sl2-proof-x').onclick=closeM;
    ol.querySelector('.sl2-proof-back').onclick=closeM;
    ol.addEventListener('click',function(e){if(e.target===ol)closeM();});
    if(!blocked){
      var cb=ol.querySelector('#sl2-proof-ack-cb'),okBtn=ol.querySelector('.sl2-proof-ok');
      cb.addEventListener('change',function(){okBtn.disabled=!cb.checked;});
      okBtn.onclick=function(){
        if(!cb.checked)return;
        closeM();
        if(onApprove)onApprove();
      };
    }
  };
})();

/* ══════════ FINISH-AWARE PREVIEW CANVAS ══════════
   Two-stage approach matching editor:
   - _sl2Cnv: creates the sticker canvas (no padding, filters only for glossy/matte
     which are simple color adjustments — no layer compositing needed).
   - _sl2HoloFinalize: takes a rendered sticker canvas and composites it onto a
     larger canvas filled with the real CloudFront holographic image using
     multiply blend at the LAYER level (one multiply of full sticker × holo bg,
     exactly like editor's mix-blend-mode on the canvas element). */
window._sl2Cnv=async function(pvW,pvH,finish){
  var pc=document.createElement('canvas');pc.width=pvW;pc.height=pvH;
  var ctx=pc.getContext('2d');
  ctx.save();
  if(finish==='glossy'&&ctx.filter!==undefined)ctx.filter='contrast(1.18) saturate(1.30) brightness(1.02)';
  else if(finish==='matte'&&ctx.filter!==undefined)ctx.filter='contrast(1.10) saturate(1.15) brightness(1.01)';
  return {canvas:pc,ctx:ctx,pad:0};
};
window._sl2HoloFinalize=async function(stickerCanvas,shapePath,padIn){
  /* Caller provides padIn (preview pixels) matching user's cut style so the
     holo ring matches the editor border. padIn=0 means edge cut (no ring). */
  var pvW=stickerCanvas.width,pvH=stickerCanvas.height;
  var pad=padIn!=null?padIn:Math.round(Math.min(pvW,pvH)*0.01);
  var tW=pvW+pad*2,tH=pvH+pad*2;
  var pc=document.createElement('canvas');pc.width=tW;pc.height=tH;
  var ctx=pc.getContext('2d');
  /* Cache holo image globally so we only fetch once per session. */
  if(window._sl2HoloImg===undefined){
    try{
      window._sl2HoloImg=await new Promise(function(res,rej){
        var img=new Image();img.crossOrigin='anonymous';
        img.onload=function(){res(img);};
        img.onerror=function(){rej();};
        img.src='https://d6ce0no7ktiq.cloudfront.net/images/web/preview/effects/holoimage.png';
        setTimeout(rej,4500);
      });
    }catch(e){window._sl2HoloImg=null;}
  }
  /* Step 1: fill entire canvas with holo bg */
  var drew=false;
  if(window._sl2HoloImg){
    try{
      var himg=window._sl2HoloImg;
      var s=Math.max(tW/himg.width,tH/himg.height)*1.5;
      var sw=himg.width*s,sh=himg.height*s;
      ctx.drawImage(himg,(tW-sw)/2,(tH-sh)/2,sw,sh);
      drew=true;
    }catch(e){}
  }
  if(!drew){
    try{
      var g=ctx.createConicGradient(Math.PI*0.15,tW/2,tH/2);
      g.addColorStop(0,'#f5b4d8');g.addColorStop(.16,'#a9c7ef');g.addColorStop(.33,'#a9e6ef');
      g.addColorStop(.5,'#b4e9a7');g.addColorStop(.66,'#efe28e');g.addColorStop(.83,'#f5c28e');
      g.addColorStop(1,'#f5b4d8');
      ctx.fillStyle=g;
    }catch(e){ctx.fillStyle='#ddc8ec';}
    ctx.fillRect(0,0,tW,tH);
  }
  /* Step 2: build dilated mask from the cut shape (preferred) or sticker alpha
     (fallback). Fill the shape with opaque white + shadowBlur to extend alpha
     outward by ~pad, then threshold to binary. Using the cut SHAPE (not sticker
     alpha) ensures the mask covers the full sticker region including transparent
     backing — so holo shows through in the backing area + the outer ring. */
  var mask=document.createElement('canvas');mask.width=tW;mask.height=tH;
  var mCtx=mask.getContext('2d');
  mCtx.shadowColor='rgba(255,255,255,1)';
  mCtx.shadowBlur=pad*1.8;
  if(shapePath&&shapePath.length>=3){
    mCtx.fillStyle='#fff';
    mCtx.beginPath();
    mCtx.moveTo(shapePath[0][0]+pad,shapePath[0][1]+pad);
    for(var j=1;j<shapePath.length;j++)mCtx.lineTo(shapePath[j][0]+pad,shapePath[j][1]+pad);
    mCtx.closePath();
    mCtx.fill();
  } else {
    mCtx.drawImage(stickerCanvas,pad,pad);
  }
  try{
    var imgD=mCtx.getImageData(0,0,tW,tH),dt=imgD.data;
    for(var i=3;i<dt.length;i+=4)dt[i]=dt[i]>15?255:0;
    mCtx.putImageData(imgD,0,0);
  }catch(e){}
  /* Step 3: clip holo by mask alpha — keep only pixels where dilated sticker is */
  ctx.globalCompositeOperation='destination-in';
  ctx.drawImage(mask,0,0);
  /* Step 4: composite sticker on top with multiply + brightness/saturate — matches
     the editor's `.sms-sticker-stage.finish-holographic canvas { mix-blend-mode:
     multiply; filter: brightness(1.35) saturate(1.2); }` exactly. Result: design
     gets tinted by the underlying holo colors (same iridescent look as editor),
     backing areas tinted too, outer ring shows pure holo. */
  ctx.globalCompositeOperation='multiply';
  if(ctx.filter!==undefined)ctx.filter='brightness(1.35) saturate(1.2)';
  ctx.drawImage(stickerCanvas,pad,pad);
  return pc;
};

/* ══════════ PREVIEW CACHE ══════════
   Stores the most recent capturePreview output for fallback rendering when
   R2 upload fails:
   - window._sl2LastPreview: blob URL for in-page cart drawer
   - sessionStorage['sl2-thumb-{sessionId}']: small JPEG data URL for cart page */
window._sl2CachePreview=function(bytes,sessionId){
  if(!bytes)return;
  try{
    if(window._sl2LastPreview)URL.revokeObjectURL(window._sl2LastPreview);
    var blob=new Blob([bytes],{type:'image/png'});
    window._sl2LastPreview=URL.createObjectURL(blob);
    var img=new Image();
    img.onload=function(){
      try{
        var tw=200,th=Math.round(200*img.height/img.width);
        var c=document.createElement('canvas');c.width=tw;c.height=th;
        c.getContext('2d').drawImage(img,0,0,tw,th);
        sessionStorage.setItem('sl2-thumb-'+sessionId,c.toDataURL('image/jpeg',0.55));
      }catch(e){}
    };
    img.src=window._sl2LastPreview;
  }catch(e){}
};


/* ══════════ MERGE NEARBY CUT PATHS (concave-hull-ish via morph close) ══════════
   When the editor has multiple disconnected elements (text + image, scattered
   text letters), drawCutline produces multiple cut paths. This bridges gaps
   between them via dilate-then-erode, producing a single merged path that hugs
   the elements (like a concave hull). If they're too far apart to bridge, returns
   the original paths unchanged — NEVER falls back to a generic bounding rect. */
window._sl2MergePaths=function(paths,CS){
  if(!window.ClipperLib||!paths||paths.length<2)return paths;
  /* Bridge size in canvas-units: 60px. Big enough for text letter gaps and
     normal element spacing; small enough to stay close to original shape. */
  var bridge=60;
  try{
    var co=new ClipperLib.ClipperOffset();co.ArcTolerance=0.5*CS;
    paths.forEach(function(p){
      co.AddPath(p,ClipperLib.JoinType.jtRound,ClipperLib.EndType.etClosedPolygon);
    });
    var dilated=new ClipperLib.Paths();co.Execute(dilated,bridge*CS);
    if(!dilated.length)return paths;
    var co2=new ClipperLib.ClipperOffset();co2.ArcTolerance=0.5*CS;
    dilated.forEach(function(p){
      co2.AddPath(p,ClipperLib.JoinType.jtRound,ClipperLib.EndType.etClosedPolygon);
    });
    var merged=new ClipperLib.Paths();co2.Execute(merged,-bridge*CS);
    return merged.length?merged:paths;
  }catch(e){return paths;}
};

/* ══════════ BORDER SIZE SMART HINT ══════════
   When the user has a die-cut design with multiple separate elements AND
   Small/Edge border selected, drawCutline produces multiple cut paths.
   This shows a one-time hint suggesting they bump to Medium/Large border
   to merge into a single sticker (which works naturally via cut offset
   overlap, see drawCutline's union behavior). */
window._sl2CheckHint=function(){
  /* Show only once per session */
  try{if(sessionStorage.getItem('sl2-hint-border'))return;}catch(e){}
  var st=window._sl2St;
  if(!st||!st.canvas)return;
  if(st.shape!=='die-cut')return;
  if(st.cutStyle!=='tight'&&st.cutStyle!=='none')return;
  /* Need 2+ visible non-cutline objects for multi-path scenario */
  var els=st.canvas.getObjects().filter(function(o){
    return !o._isCutline&&!o._isScissorIcon&&o.visible!==false;
  });
  if(els.length<2)return;
  /* Check if cut produced multiple paths (multiple "M" commands in svg) */
  var path=st.cutContourPath||'';
  var mCount=(path.match(/M /g)||[]).length;
  if(mCount<2)return;
  /* Find border button to anchor tooltip near */
  var anchor=document.querySelector('.sms-tool-icon[data-cut="medium"]')
          ||document.querySelector('.sms-tool-icon[data-cut="loose"]')
          ||document.querySelector('.sms-tool-icon[data-cut]');
  if(!anchor)return;
  /* Remove any existing hint */
  var old=document.getElementById('sl2-bhint');if(old)old.remove();
  /* Build tooltip */
  var t=document.createElement('div');
  t.id='sl2-bhint';t.className='sl2-bhint';
  t.innerHTML='\ud83d\udca1 Multiple elements detected. Try <b>Medium</b> or <b>Large</b> border to merge them into one sticker. <button type="button">Got it</button>';
  document.body.appendChild(t);
  /* Position above the anchor button */
  var rect=anchor.getBoundingClientRect();
  var tw=t.offsetWidth,th=t.offsetHeight;
  t.style.left=Math.max(8,Math.min(window.innerWidth-tw-8,rect.left+rect.width/2-tw/2))+'px';
  t.style.top=Math.max(8,rect.top-th-12)+'px';
  /* Dismiss handlers */
  function dismiss(){if(t.parentNode)t.remove();try{sessionStorage.setItem('sl2-hint-border','1');}catch(e){}}
  t.querySelector('button').onclick=dismiss;
  /* Auto-dismiss after 9s */
  setTimeout(dismiss,9000);
  /* Dismiss when user changes border */
  document.querySelectorAll('.sms-tool-icon[data-cut]').forEach(function(b){
    b.addEventListener('click',dismiss,{once:true});
  });
};

/* ── Bring to Front button (Edit panel) ──────────────────────────────────────
   Injected into the Edit toolbar from JS because the liquid section file is at
   the 256KB Shopify limit. Sits next to Delete/Reset. Brings the currently
   selected object to the top of the canvas z-order. If nothing is selected and
   only one non-cutline object exists, that object is auto-selected. Saves an
   undo state via the existing object:modified listener.
*/
(function(){
  function inject(){
    if(document.getElementById('btnFront')) return true;
    var del=document.getElementById('btnDelete');
    if(!del||!del.parentElement) return false;
    var b=document.createElement('button');
    b.className='sms-tool-icon disabled';
    b.id='btnFront';
    b.title='Bring selected element to front';
    b.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="2" width="13" height="13" rx="2"/><rect x="3" y="9" width="13" height="13" rx="2" stroke-dasharray="3 2"/></svg><span>Front</span>';
    del.parentElement.insertBefore(b,del);
    b.addEventListener('click',function(){
      if(b.classList.contains('disabled'))return;
      var st=window._sl2St;if(!st||!st.canvas)return;
      var c=st.canvas;
      var obj=c.getActiveObject();
      if(!obj||obj._isCutline){
        var pick=c.getObjects().filter(function(o){return !o._isCutline;});
        if(pick.length===1){obj=pick[0];c.setActiveObject(obj);}
        else if(pick.length>1){
          /* Show a quick toast — user must select an object first */
          var t=document.createElement('div');
          t.textContent='Tap an element on the canvas first, then press Front.';
          t.style.cssText='position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#0f172a;color:#fff;padding:10px 16px;border-radius:8px;font-size:13px;font-weight:500;z-index:99999;box-shadow:0 4px 12px rgba(0,0,0,0.3);max-width:90vw;text-align:center;';
          document.body.appendChild(t);
          setTimeout(function(){t.style.transition='opacity 0.3s';t.style.opacity='0';setTimeout(function(){t.remove();},300);},2200);
          return;
        } else return;
      }
      obj.bringToFront();
      c.renderAll();
      /* Trigger the section's object:modified hook so saveState fires (undo) */
      try{c.fire('object:modified',{target:obj});}catch(e){}
    });
    return true;
  }
  function sync(){
    var b=document.getElementById('btnFront');if(!b)return;
    var st=window._sl2St;
    var n=0;
    if(st&&st.canvas){
      n=st.canvas.getObjects().filter(function(o){return !o._isCutline;}).length;
    }
    /* Enable when there are 2+ stackable objects (otherwise reordering is a no-op) */
    if(n>=2)b.classList.remove('disabled');
    else b.classList.add('disabled');
  }
  function init(){if(inject())sync();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
  setTimeout(init,500);
  setTimeout(init,1500);
  setInterval(sync,800);
})();

/* Background-removal helpers with timeout, retry, error-body capture, console logging.
   _sl2BgPro: cloud (backgrounderase.com v2) — returns Blob.
   _sl2BgAi:  local imgly (WASM ONNX) — returns Blob.
   Caller wraps result with cleanAlphaEdges. */
window._sl2BgPro=async function(blob,opts){
  opts=opts||{};
  /* Routes through our Cloudflare Worker proxy (print-api.stickermint.workers.dev)
     which forwards to backgrounderase.com with the server-side API key.
     Worker accepts raw image bytes in body — no multipart needed. */
  var url=opts.url||'https://print-api.stickermint.workers.dev/bg-remove';
  var timeoutMs=opts.timeoutMs||60000;
  var maxAttempts=opts.maxAttempts||2;
  var lastErr=null;
  for(var attempt=1; attempt<=maxAttempts; attempt++){
    var ctrl=new AbortController();
    var to=setTimeout(function(){ctrl.abort();},timeoutMs);
    try{
      var resp=await fetch(url,{method:'POST',headers:{'Content-Type':blob.type||'image/png'},body:blob,signal:ctrl.signal});
      clearTimeout(to);
      if(resp.ok)return await resp.blob();
      var bodyTxt='';
      try{bodyTxt=(await resp.clone().text()).slice(0,300);}catch(_){}
      console.error('[bg-pro] HTTP '+resp.status+' '+resp.statusText+' attempt '+attempt+'/'+maxAttempts+' body='+bodyTxt);
      var bodyShort=bodyTxt.replace(/\s+/g,' ').slice(0,120);
      lastErr=new Error('Cloud bg-removal failed (HTTP '+resp.status+(bodyShort?': '+bodyShort:'')+')');
      if(resp.status<500||attempt===maxAttempts)throw lastErr;
    }catch(e){
      clearTimeout(to);
      if(e&&e.name==='AbortError'){
        console.error('[bg-pro] timeout '+timeoutMs+'ms attempt '+attempt+'/'+maxAttempts);
        lastErr=new Error('Cloud bg-removal timed out after '+(timeoutMs/1000)+'s');
      }else if(!lastErr){
        console.error('[bg-pro] network error attempt '+attempt+'/'+maxAttempts,e);
        lastErr=e;
      }
      if(attempt===maxAttempts)throw lastErr;
    }
  }
  throw lastErr||new Error('Cloud bg-removal failed');
};

window._sl2ProCBlob=async function(originalImg){
  var tc=document.createElement('canvas');
  var sW=originalImg.naturalWidth||originalImg.width, sH=originalImg.naturalHeight||originalImg.height;
  var r=Math.min(2048/sW,2048/sH,1);
  tc.width=Math.round(sW*r); tc.height=Math.round(sH*r);
  tc.getContext('2d').drawImage(originalImg,0,0,tc.width,tc.height);
  return await new Promise(function(res){tc.toBlob(res,'image/png');});
};

window._sl2BgAi=async function(originalImg,onProgress){
  if(!window._imglyBgRemoval){
    if(onProgress)onProgress('Loading AI model...');
    try{
      var mod=await import('https://cdn.jsdelivr.net/npm/@imgly/background-removal@1.5.1/+esm');
      window._imglyBgRemoval=mod;
    }catch(e){
      console.error('[bg-ai] model import failed',e);
      throw new Error('Could not load AI model: '+(e&&e.message||'network/CORS'));
    }
  }
  var imgly=window._imglyBgRemoval;
  var sW=originalImg.naturalWidth||originalImg.width;
  var sH=originalImg.naturalHeight||originalImg.height;
  var scale=Math.min(1024/sW,1024/sH,1);
  var tc=document.createElement('canvas');
  tc.width=Math.round(sW*scale);tc.height=Math.round(sH*scale);
  tc.getContext('2d').drawImage(originalImg,0,0,tc.width,tc.height);
  var blob=await new Promise(function(res){tc.toBlob(res,'image/png');});
  if(onProgress)onProgress('Removing background...');
  try{
    return await imgly.removeBackground(blob,{
      model:'isnet_quint8',
      progress:function(key,current,total){
        if(key==='compute:inference'&&onProgress)onProgress('Processing... '+Math.round(current/total*100)+'%');
      }
    });
  }catch(e){
    console.error('[bg-ai] inference failed',e);
    throw new Error('AI removal failed: '+(e&&e.message||'unknown'));
  }
};

/* ════════ Manual eraser + fill brushes ════════
   Lets the user paint transparency (erase) or paint opaque white (fill) on the
   current canvas. Used to clean up AI bg-removal artifacts and merge shapes.
   Returns an api: { setMode, setSize, getMode, destroy }.
   opts: { state, saveState, onCommit, fabricRef } */
window._sl2InitEraser=function(opts){
  var st=opts.state, saveSt=opts.saveState, onCommit=opts.onCommit;
  var fab=opts.fabricRef||window.fabric;
  var mode='off', brushPx=50, painting=false, lastPt=null;
  var workC=null, overlay=null, listening=false;

  function getImg(){
    if(!st||!st.canvas)return null;
    var arr=st.canvas.getObjects('image');
    return arr.length?arr[0]:null;
  }
  function rebuildWork(){
    var img=getImg();if(!img)return false;
    var el=img._element||img.getElement();
    var w=el.naturalWidth||el.width, h=el.naturalHeight||el.height;
    if(!w||!h)return false;
    workC=document.createElement('canvas');
    workC.width=w;workC.height=h;
    workC.getContext('2d').drawImage(el,0,0);
    img._element=workC;
    img._originalElement=workC;
    img.dirty=true;
    st.canvas.requestRenderAll();
    return true;
  }
  function ptToImg(opt){
    var img=getImg();if(!img)return null;
    /* Compute canvas-internal coords directly from clientX/Y + canvas BCR.
       This stays in sync with the cursor (which also uses clientX/Y) regardless
       of any CSS scale on #stickerStage. */
    var e=opt.e;
    var cx=e.clientX!=null?e.clientX:(e.touches&&e.touches[0]?e.touches[0].clientX:0);
    var cy=e.clientY!=null?e.clientY:(e.touches&&e.touches[0]?e.touches[0].clientY:0);
    var el=st.canvas.upperCanvasEl||st.canvas.lowerCanvasEl;
    var rect=el.getBoundingClientRect();
    var canvasX=(cx-rect.left)*(st.canvas.width/rect.width);
    var canvasY=(cy-rect.top)*(st.canvas.height/rect.height);
    /* Apply viewport transform inverse so we get pre-zoom canvas coords */
    var vpt=st.canvas.viewportTransform;
    if(vpt){
      var ivpt=fab.util.invertTransform(vpt);
      var p=fab.util.transformPoint({x:canvasX,y:canvasY},ivpt);
      canvasX=p.x;canvasY=p.y;
    }
    var inv=fab.util.invertTransform(img.calcTransformMatrix());
    var ip=fab.util.transformPoint({x:canvasX,y:canvasY},inv);
    return {x:ip.x+img.width/2, y:ip.y+img.height/2};
  }
  function paint(from,to){
    if(!workC)return;
    var ctx=workC.getContext('2d');
    var img=getImg();if(!img)return;
    if(mode==='erase'){
      ctx.save();
      ctx.globalCompositeOperation='destination-out';
      ctx.lineCap='round';ctx.lineJoin='round';
      ctx.lineWidth=brushPx*2;
      ctx.strokeStyle='rgba(0,0,0,1)';
      if(from&&to&&(from.x!==to.x||from.y!==to.y)){
        ctx.beginPath();ctx.moveTo(from.x,from.y);ctx.lineTo(to.x,to.y);ctx.stroke();
      }
      ctx.beginPath();ctx.arc(to.x,to.y,brushPx,0,Math.PI*2);
      ctx.fillStyle='rgba(0,0,0,1)';ctx.fill();
      ctx.restore();
    }else if(mode==='fill'){
      /* Fill mode: paint opaque white over current pixels (extends the alpha so cutline
         wraps the new region — useful for closing gaps between text or merging shapes). */
      ctx.save();
      ctx.globalCompositeOperation='source-over';
      ctx.lineCap='round';ctx.lineJoin='round';
      ctx.lineWidth=brushPx*2;
      ctx.strokeStyle='#ffffff';
      if(from&&to&&(from.x!==to.x||from.y!==to.y)){
        ctx.beginPath();ctx.moveTo(from.x,from.y);ctx.lineTo(to.x,to.y);ctx.stroke();
      }
      ctx.beginPath();ctx.arc(to.x,to.y,brushPx,0,Math.PI*2);
      ctx.fillStyle='#ffffff';ctx.fill();
      ctx.restore();
    }
    _hasEdits=true;
    /* objectCaching is off in brush mode so we don't need img.dirty per stroke;
       the canvas reads the workCanvas pixels directly each render. */
    st.canvas.requestRenderAll();
  }
  function ensureOverlay(){
    if(overlay)return;
    overlay=document.createElement('div');
    overlay.style.cssText='position:fixed;border:2px solid #00c9a7;border-radius:50%;pointer-events:none;display:none;z-index:9999;background:rgba(0,201,167,0.12);box-shadow:0 0 0 1px rgba(0,0,0,0.5);';
    document.body.appendChild(overlay);
  }
  function showCursor(opt){
    if(!overlay)return;
    var img=getImg();if(!img){overlay.style.display='none';return;}
    var e=opt.e;
    var x=e.clientX!=null?e.clientX:(e.touches&&e.touches[0]?e.touches[0].clientX:0);
    var y=e.clientY!=null?e.clientY:(e.touches&&e.touches[0]?e.touches[0].clientY:0);
    /* Include the studio's CSS stage transform so the cursor matches what's actually
       painted on screen (otherwise brush is bigger than the cursor when zoomed-in). */
    var stageScale=window._sl2ZoomLevel||1;
    var sR=brushPx*img.scaleX*st.canvas.getZoom()*stageScale;
    overlay.style.display='block';
    overlay.style.left=(x-sR)+'px';overlay.style.top=(y-sR)+'px';
    overlay.style.width=(sR*2)+'px';overlay.style.height=(sR*2)+'px';
  }
  function hideCursor(){if(overlay)overlay.style.display='none';}
  function onDown(opt){
    if(mode==='off')return;
    var pt=ptToImg(opt);if(!pt)return;
    painting=true;lastPt=pt;
    paint(null,pt);
  }
  function onMove(opt){
    showCursor(opt);
    if(!painting)return;
    var pt=ptToImg(opt);if(!pt)return;
    paint(lastPt,pt);
    lastPt=pt;
  }
  function onUp(){
    if(!painting)return;
    painting=false;lastPt=null;
    /* Per-stroke is hot path — keep it bare. saveState + onCommit
       (recenter + drawCutline) all defer to setMode('off') i.e. Done click. */
  }
  function attach(){
    if(listening||!st.canvas)return;
    st.canvas.on('mouse:down',onDown);
    st.canvas.on('mouse:move',onMove);
    st.canvas.on('mouse:up',onUp);
    st.canvas.on('mouse:out',hideCursor);
    listening=true;
  }
  function detach(){
    if(!listening||!st.canvas)return;
    st.canvas.off('mouse:down',onDown);
    st.canvas.off('mouse:move',onMove);
    st.canvas.off('mouse:up',onUp);
    st.canvas.off('mouse:out',hideCursor);
    listening=false;
  }
  /* Saved Fabric state so we can restore on Done */
  var _savedSel=null, _savedSkip=null, _savedDef=null, _savedHov=null, _savedCaching=null, _hasEdits=false;
  /* Tilt-suppression: pin the stage transform on a rAF loop so the canvas's BCR
     stays accurate (tilted canvas → wrong BCR → cursor/paint misalignment). */
  var _savedAdjusting=null, _savedTransform=null, _pinRaf=0;
  function _pinFlat(){
    if(mode==='off'){_pinRaf=0;return;}
    var stageEl=document.getElementById('stickerStage');
    if(stageEl){
      var zl=window._sl2ZoomLevel||1;
      var want='scale('+zl+') rotateX(0) rotateY(0)';
      if(stageEl.style.transform!==want)stageEl.style.transform=want;
    }
    _pinRaf=requestAnimationFrame(_pinFlat);
  }
  function setMode(m){
    if(m===mode)return;
    var prev=mode; mode=m;
    if(mode==='off'){
      detach();hideCursor();
      if(overlay){overlay.remove();overlay=null;}
      if(_pinRaf){cancelAnimationFrame(_pinRaf);_pinRaf=0;}
      var img=getImg();
      if(img){
        img.selectable=true;img.evented=true;
        if(_savedCaching!==null)img.objectCaching=_savedCaching;
        img.dirty=true;
      }
      if(st.canvas){
        if(_savedSel!==null)st.canvas.selection=_savedSel;
        if(_savedSkip!==null)st.canvas.skipTargetFind=_savedSkip;
        if(_savedDef!==null)st.canvas.defaultCursor=_savedDef;
        if(_savedHov!==null)st.canvas.hoverCursor=_savedHov;
        _savedSel=_savedSkip=_savedDef=_savedHov=_savedCaching=null;
        st.canvas.requestRenderAll();
      }
      /* Restore tilt state */
      if(_savedAdjusting!==null)st.adjusting=_savedAdjusting;
      _savedAdjusting=null;
      var stageEl2=document.getElementById('stickerStage');
      if(stageEl2&&_savedTransform!==null)stageEl2.style.transform=_savedTransform;
      _savedTransform=null;
      /* Run heavy ops only if user actually painted something. Defer to next frame
         so the Done click repaints first (avoids freeze impression). */
      if(_hasEdits){
        _hasEdits=false;
        var doneWC=workC;
        requestAnimationFrame(function(){
          if(saveSt)try{saveSt();}catch(e){console.error('[brush] saveState',e);}
          if(onCommit&&doneWC)try{onCommit(doneWC);}catch(e){console.error('[brush] onCommit',e);}
        });
      }
      return;
    }
    if(prev==='off'){
      if(!rebuildWork()){mode='off';return;}
      _hasEdits=false;
      if(st.canvas){
        _savedSel=st.canvas.selection;
        _savedSkip=st.canvas.skipTargetFind;
        _savedDef=st.canvas.defaultCursor;
        _savedHov=st.canvas.hoverCursor;
        st.canvas.selection=false;
        st.canvas.skipTargetFind=true;
        st.canvas.defaultCursor='none';
        st.canvas.hoverCursor='none';
        st.canvas.discardActiveObject();
      }
      var img=getImg();
      if(img){
        _savedCaching=img.objectCaching;
        /* Disable object cache so dirty pixels show up without an expensive
           offscreen rasterize each stroke. workCanvas → main canvas is cheap. */
        img.objectCaching=false;
      }
      /* Pin stage flat so BCR matches canvas pixels 1:1 (cursor/paint align). */
      _savedAdjusting=st.adjusting;
      st.adjusting=true;
      var stageEl=document.getElementById('stickerStage');
      if(stageEl){
        _savedTransform=stageEl.style.transform;
        var zl=window._sl2ZoomLevel||1;
        stageEl.style.transform='scale('+zl+') rotateX(0) rotateY(0)';
      }
      _pinRaf=requestAnimationFrame(_pinFlat);
    }
    ensureOverlay();attach();
    var imgX=getImg();
    if(imgX){imgX.selectable=false;imgX.evented=false;}
  }
  function setSize(px){brushPx=Math.max(1,px|0);}
  return {
    setMode:setMode,setSize:setSize,
    getMode:function(){return mode;},
    getSize:function(){return brushPx;},
    destroy:function(){setMode('off');}
  };
};

/* ════════ Marquee Crop / Cut tool ════════
   Drag a rectangle, choose Keep (everything else → transparent) or Delete
   (just the rect → transparent). Two-step: rect + action popup. */
window._sl2InitCrop=function(opts){
  var st=opts.state, fab=opts.fabricRef||window.fabric;
  var saveSt=opts.saveState, onCommit=opts.onCommit;
  var active=false, dragging=false, startPt=null, endPt=null;
  var workC=null, rectOv=null, popup=null, listening=false;
  var _sel=null,_skip=null,_def=null,_hov=null,_caching=null;

  function getImg(){var arr=st.canvas&&st.canvas.getObjects('image');return arr&&arr.length?arr[0]:null;}
  function rebuildWork(){
    var img=getImg();if(!img)return false;
    var el=img._element||img.getElement();
    var w=el.naturalWidth||el.width, h=el.naturalHeight||el.height;
    if(!w||!h)return false;
    workC=document.createElement('canvas');
    workC.width=w;workC.height=h;
    workC.getContext('2d').drawImage(el,0,0);
    img._element=workC;img._originalElement=workC;
    img.dirty=true;st.canvas.requestRenderAll();
    return true;
  }
  function clientToImg(cx,cy){
    var img=getImg();if(!img)return null;
    /* Force the stage flat right before reading BCR — synchronously, not on the
       next rAF — so any tilt that just got written gets cleared before we measure. */
    if(active){
      var stageEl=document.getElementById('stickerStage');
      if(stageEl){
        var zl=window._sl2ZoomLevel||1;
        var want='scale('+zl+') rotateX(0) rotateY(0)';
        if(stageEl.style.transform!==want)stageEl.style.transform=want;
      }
    }
    var el=st.canvas.upperCanvasEl||st.canvas.lowerCanvasEl;
    var r=el.getBoundingClientRect();
    var canvasX=(cx-r.left)*(st.canvas.width/r.width);
    var canvasY=(cy-r.top)*(st.canvas.height/r.height);
    var vpt=st.canvas.viewportTransform;
    if(vpt){
      var iv=fab.util.invertTransform(vpt);
      var p=fab.util.transformPoint({x:canvasX,y:canvasY},iv);
      canvasX=p.x;canvasY=p.y;
    }
    var inv=fab.util.invertTransform(img.calcTransformMatrix());
    var ip=fab.util.transformPoint({x:canvasX,y:canvasY},inv);
    return {x:ip.x+img.width/2, y:ip.y+img.height/2};
  }
  /* Reverse of clientToImg: image-pixel coords → screen coords. Used so the visual
     rect we draw is positioned at the EXACT spot the cut will land — no drift. */
  function imgToClient(ix,iy){
    var img=getImg();if(!img)return null;
    var el=st.canvas.upperCanvasEl||st.canvas.lowerCanvasEl;
    var r=el.getBoundingClientRect();
    var localX=ix-img.width/2, localY=iy-img.height/2;
    var pre=fab.util.transformPoint({x:localX,y:localY},img.calcTransformMatrix());
    var vpt=st.canvas.viewportTransform;
    if(vpt){pre=fab.util.transformPoint(pre,vpt);}
    var screenX=r.left+pre.x*(r.width/st.canvas.width);
    var screenY=r.top+pre.y*(r.height/st.canvas.height);
    return {x:screenX,y:screenY};
  }
  function ensureOv(){
    if(rectOv)return;
    rectOv=document.createElement('div');
    rectOv.style.cssText='position:fixed;border:2px dashed #00c9a7;background:rgba(0,201,167,0.10);pointer-events:none;display:none;z-index:9999;box-shadow:0 0 0 1px rgba(0,0,0,0.4);';
    document.body.appendChild(rectOv);
  }
  function showOv(s,e){
    if(!rectOv)return;
    var x=Math.min(s.x,e.x),y=Math.min(s.y,e.y);
    var w=Math.abs(e.x-s.x),h=Math.abs(e.y-s.y);
    rectOv.style.display='block';
    rectOv.style.left=x+'px';rectOv.style.top=y+'px';
    rectOv.style.width=w+'px';rectOv.style.height=h+'px';
  }
  function hideOv(){if(rectOv)rectOv.style.display='none';}
  function getEvtXY(opt){
    var e=opt.e;
    var x=e.clientX!=null?e.clientX:(e.touches&&e.touches[0]?e.touches[0].clientX:0);
    var y=e.clientY!=null?e.clientY:(e.touches&&e.touches[0]?e.touches[0].clientY:0);
    return {x:x,y:y};
  }
  /* Image-coord rect (single source of truth — visual + cut both derived from this) */
  var startImg=null, endImg=null;
  function _clamp(v,lo,hi){return Math.max(lo,Math.min(hi,v));}
  function _clampedRectImg(){
    if(!startImg||!endImg||!workC)return null;
    /* Clip both endpoints to image bounds BEFORE computing rect so a drag starting
       outside the image (e.g. above the top edge) doesn't produce a too-tall rect. */
    var p1x=_clamp(startImg.x,0,workC.width),  p1y=_clamp(startImg.y,0,workC.height);
    var p2x=_clamp(endImg.x,  0,workC.width),  p2y=_clamp(endImg.y,  0,workC.height);
    return {x1:Math.min(p1x,p2x),y1:Math.min(p1y,p2y),x2:Math.max(p1x,p2x),y2:Math.max(p1y,p2y)};
  }
  function _showRectFromImg(){
    if(!rectOv)return;
    var r=_clampedRectImg();
    if(!r){rectOv.style.display='none';return;}
    var s=imgToClient(r.x1,r.y1), e=imgToClient(r.x2,r.y2);
    if(!s||!e)return;
    var x=Math.min(s.x,e.x),y=Math.min(s.y,e.y);
    var w=Math.abs(e.x-s.x),h=Math.abs(e.y-s.y);
    rectOv.style.display='block';
    rectOv.style.left=x+'px';rectOv.style.top=y+'px';
    rectOv.style.width=w+'px';rectOv.style.height=h+'px';
  }
  function onDown(opt){
    if(!active)return;
    /* If the Fabric image's element was swapped (e.g. by _sl2RecenterAfterEdit after
       a previous crop), our local workC reference is stale. Rebuild to point at the
       current canvas. Otherwise the second crop draws onto an orphaned canvas. */
    var img=getImg();
    if(img && img._element !== workC){
      if(!rebuildWork())return;
    }
    dragging=true;
    var sp=getEvtXY(opt);
    startPt=sp;endPt=sp;
    var p=clientToImg(sp.x,sp.y);
    if(!p){dragging=false;return;}
    startImg=p;endImg=p;
    _showRectFromImg();
  }
  function onMove(opt){
    if(!dragging)return;
    endPt=getEvtXY(opt);
    var p=clientToImg(endPt.x,endPt.y);
    if(p)endImg=p;
    _showRectFromImg();
  }
  function onUp(opt){
    if(!dragging)return;
    dragging=false;
    if(!startImg||!endImg){console.warn('[crop] no img coords');hideOv();return;}
    var clipped=_clampedRectImg();
    if(!clipped){hideOv();console.warn('[crop] no workC');return;}
    var rw=Math.round(clipped.x2-clipped.x1), rh=Math.round(clipped.y2-clipped.y1);
    if(rw<2||rh<2){hideOv();console.warn('[crop] rect too small in img px',rw,rh);return;}
    /* Use the same clamped image-coord rect that _showRectFromImg drew — visual + cut
       are now identical, regardless of whether the drag started inside or outside the image. */
    var rx=Math.round(clipped.x1), ry=Math.round(clipped.y1);
    if(rw<2||rh<2){hideOv();console.warn('[crop] image-pixel rect too small',rw,rh);return;}
    /* Position popup near the bottom-right corner of the rect (in screen coords) */
    var popPt=imgToClient(rx+rw,ry+rh)||{x:endPt.x,y:endPt.y};
    showActionPopup(popPt.x,popPt.y,{x:rx,y:ry,w:rw,h:rh});
  }
  function showActionPopup(screenX,screenY,rectImgPx){
    if(popup)popup.remove();
    popup=document.createElement('div');
    /* pointer-events:auto and high z-index so Fabric canvas events can't intercept clicks */
    popup.style.cssText='position:fixed;display:flex;gap:6px;padding:8px;background:#fff;border-radius:8px;box-shadow:0 4px 16px rgba(0,0,0,0.18);z-index:100000;border:1px solid rgba(0,0,0,0.08);pointer-events:auto;';
    popup.innerHTML='<button type="button" class="_keep" style="background:#00c9a7;color:#fff;border:none;padding:6px 12px;border-radius:6px;font-size:12px;font-weight:700;cursor:pointer;">Keep Inside</button><button type="button" class="_del" style="background:#ef4444;color:#fff;border:none;padding:6px 12px;border-radius:6px;font-size:12px;font-weight:700;cursor:pointer;">Delete Inside</button><button type="button" class="_cancel" style="background:#f3f4f6;color:#444;border:none;padding:6px 10px;border-radius:6px;font-size:12px;font-weight:600;cursor:pointer;">Cancel</button>';
    /* Position so the popup stays fully on-screen */
    popup.style.left=Math.max(8,Math.min(window.innerWidth-300,screenX+8))+'px';
    popup.style.top=Math.max(8,Math.min(window.innerHeight-60,screenY+8))+'px';
    document.body.appendChild(popup);
    function _handle(action,e){
      if(e){e.preventDefault();e.stopPropagation();}
      console.log('[crop] action',action,rectImgPx);
      if(action==='cancel'){closePopup();hideOv();}else{apply(action,rectImgPx);}
    }
    popup.querySelector('._keep').addEventListener('click',function(e){_handle('keep',e);});
    popup.querySelector('._del').addEventListener('click',function(e){_handle('delete',e);});
    popup.querySelector('._cancel').addEventListener('click',function(e){_handle('cancel',e);});
  }
  function closePopup(){if(popup){popup.remove();popup=null;}}
  function apply(action,r){
    if(!workC){console.warn('[crop] apply: no workC');closePopup();return;}
    var ctx=workC.getContext('2d');
    try{
      if(action==='delete'){
        ctx.clearRect(r.x,r.y,r.w,r.h);
      }else if(action==='keep'){
        var tmp=document.createElement('canvas');
        tmp.width=workC.width;tmp.height=workC.height;
        tmp.getContext('2d').drawImage(workC,0,0);
        ctx.clearRect(0,0,workC.width,workC.height);
        ctx.drawImage(tmp,r.x,r.y,r.w,r.h,r.x,r.y,r.w,r.h);
      }
      console.log('[crop] applied',action,'rect',r.w,'x',r.h);
    }catch(e){console.error('[crop] apply failed',e);}
    var img=getImg();
    if(img){img.dirty=true;st.canvas.requestRenderAll();}
    closePopup();hideOv();
    if(saveSt)try{saveSt();}catch(_){}
    if(onCommit)try{onCommit(workC);}catch(e){console.error('[crop] onCommit failed',e);}
    /* Reset drag state so next selection works fresh */
    startPt=null;endPt=null;startImg=null;endImg=null;
  }
  function attach(){
    if(listening||!st.canvas)return;
    st.canvas.on('mouse:down',onDown);
    st.canvas.on('mouse:move',onMove);
    st.canvas.on('mouse:up',onUp);
    listening=true;
  }
  function detach(){
    if(!listening||!st.canvas)return;
    st.canvas.off('mouse:down',onDown);
    st.canvas.off('mouse:move',onMove);
    st.canvas.off('mouse:up',onUp);
    listening=false;
  }
  /* Tilt suppression: pin the stage transform on a rAF loop so any tilt handler
     writing to it gets immediately overwritten back to flat. Cheap (~0.1ms/frame)
     and bulletproof — works regardless of which handler is writing the rotation. */
  var _savedAdjusting=null, _savedTransform=null, _pinRaf=0, _outsideHandler=null;
  function _onOutsideClick(e){
    if(!active)return;
    var t=e.target;
    /* Click on the canvas itself, the popup, or the Crop button → don't exit */
    if(t.closest&&(t.closest('.sms-canvas-area')||t.closest('.upper-canvas')||t.closest('canvas')||t.closest('#btnCrop')))return;
    if(popup&&popup.contains(t))return;
    /* Click outside everything crop-related → exit crop mode */
    setMode('off');
    var btn=document.getElementById('btnCrop');
    if(btn)btn.classList.remove('active');
  }
  function _pinFlat(){
    if(!active){_pinRaf=0;return;}
    var stageEl=document.getElementById('stickerStage');
    if(stageEl){
      var zl=window._sl2ZoomLevel||1;
      var want='scale('+zl+') rotateX(0) rotateY(0)';
      if(stageEl.style.transform!==want)stageEl.style.transform=want;
    }
    _pinRaf=requestAnimationFrame(_pinFlat);
  }
  function setMode(m){
    if(m==='on'&&!active){
      if(!rebuildWork())return false;
      active=true;
      if(st.canvas){
        _sel=st.canvas.selection;_skip=st.canvas.skipTargetFind;
        _def=st.canvas.defaultCursor;_hov=st.canvas.hoverCursor;
        st.canvas.selection=false;st.canvas.skipTargetFind=true;
        st.canvas.defaultCursor='crosshair';st.canvas.hoverCursor='crosshair';
        st.canvas.discardActiveObject();st.canvas.requestRenderAll();
      }
      var img=getImg();
      if(img){_caching=img.objectCaching;img.objectCaching=false;img.selectable=false;img.evented=false;}
      _savedAdjusting=st.adjusting;
      st.adjusting=true;
      var stageEl=document.getElementById('stickerStage');
      if(stageEl){
        _savedTransform=stageEl.style.transform;
        var zl=window._sl2ZoomLevel||1;
        stageEl.style.transform='scale('+zl+') rotateX(0) rotateY(0)';
      }
      _pinRaf=requestAnimationFrame(_pinFlat);
      /* Click-outside-to-exit. Defer one tick so the click that just activated us
         doesn't immediately fire this listener and exit. */
      setTimeout(function(){
        if(active)document.addEventListener('click',_onOutsideClick,true);
      },0);
      ensureOv();attach();
      return true;
    }
    if(m==='off'&&active){
      active=false;dragging=false;
      document.removeEventListener('click',_onOutsideClick,true);
      if(_pinRaf){cancelAnimationFrame(_pinRaf);_pinRaf=0;}
      detach();hideOv();closePopup();
      if(rectOv){rectOv.remove();rectOv=null;}
      if(st.canvas){
        if(_sel!==null)st.canvas.selection=_sel;
        if(_skip!==null)st.canvas.skipTargetFind=_skip;
        if(_def!==null)st.canvas.defaultCursor=_def;
        if(_hov!==null)st.canvas.hoverCursor=_hov;
        _sel=_skip=_def=_hov=null;
        st.canvas.requestRenderAll();
      }
      var img2=getImg();
      if(img2){
        img2.selectable=true;img2.evented=true;
        if(_caching!==null)img2.objectCaching=_caching;
        img2.dirty=true;
      }
      _caching=null;
      if(_savedAdjusting!==null)st.adjusting=_savedAdjusting;
      _savedAdjusting=null;
      var stageEl2=document.getElementById('stickerStage');
      if(stageEl2&&_savedTransform!==null)stageEl2.style.transform=_savedTransform;
      _savedTransform=null;
    }
  }
  return {setMode:setMode,isActive:function(){return active;}};
};

/* Wires the eraser/fill UI: builds the floating brush bar, sets up the
   slider/done events, and exposes _sl2HandleEraserClick + _sl2ExitEraser for
   the section's bg-button click handler. Idempotent — safe to call once. */
window._sl2WireEraserUI=function(stateArg){
  if(window._sl2EraserWired)return;
  window._sl2EraserWired=true;
  var st=stateArg;
  var $=function(s){return document.querySelector(s);};
  var $$=function(s){return Array.prototype.slice.call(document.querySelectorAll(s));};
  var D={bgs:document.getElementById('bgStatus')};
  /* Inject Erase + Fill buttons next to the existing bg buttons.
     Restore goes in the Edit row next to Reset (less prominent — Undo covers most cases). */
  var proBtn=document.querySelector('.sms-tool-icon[data-bg="pro"]');
  if(st.shape!=='dtf'&&proBtn&&proBtn.parentNode&&!document.querySelector('.sms-tool-icon[data-bg="erase"]')){
    var eb=document.createElement('button');eb.className='sms-tool-icon';eb.setAttribute('data-bg','erase');eb.title='Eraser brush — manually remove leftover bits';
    eb.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M16 3l5 5-9 9H7l-4-4 9-10z"/><path d="M8 21h13"/></svg><span>Erase</span>';
    var fb=document.createElement('button');fb.className='sms-tool-icon';fb.setAttribute('data-bg','fill');fb.title='Fill brush — paint solid white to close gaps and merge shapes';
    fb.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"><path d="M19 11l-7-7-9 9 7 7 9-9z"/><path d="M5 13l8 8"/><path d="M19 11l2 4a2 2 0 1 1-4 0z"/></svg><span>Fill</span>';
    proBtn.parentNode.appendChild(eb);proBtn.parentNode.appendChild(fb);
    function _onErClick(){if(!st.originalImg)return;window._sl2HandleEraserClick(this.dataset.bg,this);}
    eb.addEventListener('click',_onErClick);
    fb.addEventListener('click',_onErClick);
  }
  /* Crop / Cut button in the Edit row, next to Reset */
  var resetBtn=document.getElementById('btnStartOver');
  if(st.shape!=='dtf'&&resetBtn&&resetBtn.parentNode&&!document.getElementById('btnCrop')){
    var cb=document.createElement('button');cb.id='btnCrop';cb.className='sms-tool-icon';cb.title='Crop / Cut — draw a rectangle to keep or delete a region';
    cb.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"><path d="M6 2v14a2 2 0 0 0 2 2h14"/><path d="M18 22V8a2 2 0 0 0-2-2H2"/></svg><span>Crop</span>';
    resetBtn.parentNode.appendChild(cb);
    cb.addEventListener('click',function(){if(!st.originalImg)return;window._sl2HandleCropClick(this);});
  }
  var area=document.querySelector('.sms-canvas-area')||document.body;
  if(area && getComputedStyle(area).position==='static')area.style.position='relative';
  var bar=document.createElement('div');
  bar.id='smsEraserBar';
  bar.style.cssText='position:absolute;top:12px;left:50%;transform:translateX(-50%);display:none;z-index:50;background:rgba(255,255,255,0.95);padding:8px 14px;border-radius:10px;box-shadow:0 2px 12px rgba(0,0,0,0.12);backdrop-filter:blur(8px);align-items:center;gap:10px;border:1px solid rgba(0,0,0,0.06);';
  bar.innerHTML='<span id="smsEraserMode" style="font-size:12px;font-weight:700;color:#00c9a7;">Erase</span><span style="font-size:11px;color:#666;">Brush</span><input type="range" id="smsEraserSize" min="5" max="250" value="50" style="width:130px;accent-color:#00c9a7;"><span id="smsEraserSizeVal" style="font-size:11px;color:#666;min-width:34px;">50px</span><button id="smsEraserDone" style="background:#00c9a7;color:#fff;border:none;padding:5px 12px;border-radius:6px;font-size:12px;font-weight:700;cursor:pointer;">Done</button>';
  area.appendChild(bar);
  function ensureApi(){
    if(window._sl2EraserApi)return window._sl2EraserApi;
    if(!window._sl2InitEraser)return null;
    var _lic=function(c){return new Promise(function(r){var i=new Image();i.onload=function(){r(i);};i.src=c.toDataURL('image/png');});};
    window._sl2EraserApi=window._sl2InitEraser({
      state:st, fabricRef:window.fabric, saveState:window._sl2SS,
      onCommit:function(wc){
        /* Per-stroke: only update processedImg async (cheap). The heavy recenter +
           drawCutline runs once on Done click (in _sl2ExitEraser) so painting stays smooth. */
        try{_lic(wc).then(function(ni){st.processedImg=ni;});}catch(e){console.error('[eraser] onCommit failed',e);}
      }
    });
    return window._sl2EraserApi;
  }
  window._sl2ExitEraser=function(){
    if(window._sl2EraserApi)window._sl2EraserApi.setMode('off');
    var b=document.getElementById('smsEraserBar');if(b)b.style.display='none';
    $$('.sms-tool-icon[data-bg="erase"],.sms-tool-icon[data-bg="fill"]').forEach(function(o){o.classList.remove('active');});
    /* Re-center + retrace cutline on Done so the user always sees a fresh outline after edits */
    if(window._sl2RecenterAfterEdit){try{window._sl2RecenterAfterEdit();}catch(e){console.error('[eraser] exit recenter failed',e);}}
    if(window._sl2DC){try{window._sl2DC();}catch(e){console.error('[eraser] exit drawCutline failed',e);}}
  };
  window._sl2HandleEraserClick=function(mode,opt){
    if(st.shape==='dtf')return;
    var api=ensureApi();if(!api){if(D&&D.bgs)D.bgs.textContent='Eraser unavailable.';return;}
    if(api.getMode()===mode){
      window._sl2ExitEraser();
      var b=$('.sms-tool-icon[data-bg="'+(st.bgMode||'none')+'"]');if(b)b.classList.add('active');
      return;
    }
    /* Make sure crop mode is off so they don't overlap */
    if(window._sl2ExitCrop)window._sl2ExitCrop();
    $$('.sms-tool-icon[data-bg="erase"],.sms-tool-icon[data-bg="fill"]').forEach(function(o){o.classList.remove('active');});
    opt.classList.add('active');
    api.setMode(mode);
    var sz=+($('#smsEraserSize').value)||50;api.setSize(sz);
    var bar=document.getElementById('smsEraserBar');if(bar)bar.style.display='flex';
    var lab=document.getElementById('smsEraserMode');if(lab)lab.textContent=mode==='erase'?'Erase':'Fill';
  };
  var size=document.getElementById('smsEraserSize'),val=document.getElementById('smsEraserSizeVal'),done=document.getElementById('smsEraserDone');
  if(size)size.addEventListener('input',function(){var v=+size.value;if(val)val.textContent=v+'px';if(window._sl2EraserApi)window._sl2EraserApi.setSize(v);});
  if(done)done.addEventListener('click',function(){
    window._sl2ExitEraser();
    var bm=st.bgMode||'none';var b=$('.sms-tool-icon[data-bg="'+bm+'"]');if(b)b.classList.add('active');
  });

  /* ──── Crop / Cut tool wiring ──── */
  function ensureCropApi(){
    if(window._sl2CropApi)return window._sl2CropApi;
    if(!window._sl2InitCrop)return null;
    var _lic=function(c){return new Promise(function(r){var i=new Image();i.onload=function(){r(i);};i.src=c.toDataURL('image/png');});};
    window._sl2CropApi=window._sl2InitCrop({
      state:st, fabricRef:window.fabric, saveState:window._sl2SS,
      onCommit:function(wc){
        try{_lic(wc).then(function(ni){
          st.processedImg=ni;
          if(window._sl2RecenterAfterEdit){try{window._sl2RecenterAfterEdit();}catch(e){console.error('[crop] recenter failed',e);}}
          if(window._sl2DC){try{window._sl2DC();}catch(e){console.error('[crop] drawCutline failed',e);}}
        });}catch(e){console.error('[crop] onCommit failed',e);}
      }
    });
    return window._sl2CropApi;
  }
  window._sl2ExitCrop=function(){
    if(window._sl2CropApi)window._sl2CropApi.setMode('off');
    var b=document.getElementById('btnCrop');if(b)b.classList.remove('active');
  };
  window._sl2HandleCropClick=function(opt){
    if(st.shape==='dtf')return;
    var api=ensureCropApi();
    if(!api){console.error('[crop] api unavailable');return;}
    if(api.isActive()){
      window._sl2ExitCrop();
      return;
    }
    /* Make sure brush mode is off so they don't overlap */
    if(window._sl2ExitEraser)window._sl2ExitEraser();
    var ok=api.setMode('on');
    if(ok===false){
      console.error('[crop] enter failed — no image on canvas');
      if(D&&D.bgs)D.bgs.textContent='Upload an image first.';
      return;
    }
    opt.classList.add('active');
  };
};

/* Self-wire eraser UI once the section has exposed state on window */
(function(){
  function wait(){
    if(window._sl2St && window.fabric && window._sl2WireEraserUI){
      window._sl2WireEraserUI(window._sl2St);
      /* Capture-phase listener on bg buttons: clicking any of them exits eraser+crop. */
      var btns=document.querySelectorAll('.sms-tool-icon[data-bg]');
      for(var i=0;i<btns.length;i++){
        var b=btns[i];
        if(b.dataset.bg!=='erase'&&b.dataset.bg!=='fill'){
          b.addEventListener('click',function(){
            if(window._sl2ExitEraser)window._sl2ExitEraser();
            if(window._sl2ExitCrop)window._sl2ExitCrop();
          },true);
        }
      }
      return;
    }
    setTimeout(wait,200);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',wait);
  else wait();
})();

/* Heavy image-processing helpers moved out of section file for size budget. */
window._sl2RemoveSolidBg=function(imgEl){
  var c=document.createElement('canvas'),W=imgEl.naturalWidth||imgEl.width,H=imgEl.naturalHeight||imgEl.height,s=Math.min(1,2048/W,2048/H),w=Math.round(W*s),h=Math.round(H*s);
  c.width=w;c.height=h;var ctx=c.getContext('2d');ctx.drawImage(imgEl,0,0,w,h);
  var id=ctx.getImageData(0,0,w,h),d=id.data;
  var corners=[[0,0],[w-1,0],[0,h-1],[w-1,h-1],[1,1],[w-2,1],[1,h-2],[w-2,h-2]];
  var rS=0,gS=0,bS=0;corners.forEach(function(p){var i=(p[1]*w+p[0])*4;rS+=d[i];gS+=d[i+1];bS+=d[i+2];});
  var bgR=Math.round(rS/8),bgG=Math.round(gS/8),bgB=Math.round(bS/8);
  /* bgTol = max RGB distance from corner-sampled bg color for a pixel to be removed.
     edgeTol = max neighbor RGB diff for the flood to propagate across.
     Tightened from 90/150 → 40/60 so the flood doesn't bleed into image content
     that's only loosely similar to the background. */
  var bgTol=40, edgeTol=60;
  var vis=new Uint8Array(w*h);
  var q=[];
  for(var x=0;x<w;x++){q.push(x,0,-1);q.push(x,h-1,-1);}
  for(var y=1;y<h-1;y++){q.push(0,y,-1);q.push(w-1,y,-1);}
  var qi=0;
  while(qi<q.length){
    var qx=q[qi++],qy=q[qi++],pi=q[qi++];
    if(qx<0||qx>=w||qy<0||qy>=h)continue;
    var idx=qy*w+qx;
    if(vis[idx])continue;
    var i=idx*4;
    if(d[i+3]<10){vis[idx]=1;d[i+3]=0;q.push(qx-1,qy,i,qx+1,qy,i,qx,qy-1,i,qx,qy+1,i);continue;}
    var dr=d[i]-bgR,dg=d[i+1]-bgG,db=d[i+2]-bgB;
    if(dr*dr+dg*dg+db*db>=bgTol*bgTol)continue;
    if(pi>=0){
      var er=d[i]-d[pi],eg=d[i+1]-d[pi+1],eb=d[i+2]-d[pi+2];
      if(er*er+eg*eg+eb*eb>=edgeTol*edgeTol)continue;
    }
    vis[idx]=1;d[i+3]=0;
    q.push(qx-1,qy,i,qx+1,qy,i,qx,qy-1,i,qx,qy+1,i);
  }
  /* Final AA fringe cleanup — zero out any pixel with alpha < 50. The flood
     fill only nukes pixels close to bg color, but the SOURCE image often has
     anti-aliased edges with partial alpha (1-49) at the boundary between
     image and bg. Without this cleanup, those AA fringe pixels stay in the
     image and inflate the downstream cutline trace mask, producing the
     "blobby cutline after Basic bg removal" symptom. After cleanup, alpha
     is binary-ish: 0 or 50+. Cutline trace produces tight outlines that
     match what a page reload (re-rendered from PNG) produces. */
  for(var ki=3;ki<d.length;ki+=4){if(d[ki]>0&&d[ki]<50)d[ki]=0;}
  ctx.putImageData(id,0,0);return c;
};

window._sl2CleanAE=function(blob,aggressive,alphaThresh){
  return new Promise(function(resolve,reject){
    var url=URL.createObjectURL(blob);
    var img=new Image();
    img.onload=function(){
      var w=img.width,h=img.height;
      var c=document.createElement('canvas');c.width=w;c.height=h;
      var ctx=c.getContext('2d');ctx.drawImage(img,0,0);
      var id=ctx.getImageData(0,0,w,h),d=id.data;
      /* alphaThresh: explicit override. Otherwise default = 20 (aggressive) or 8.
         For cloud bg removal, callers pass a higher value (~128) to break the
         gradient bridges between subject and dark fragments — the connected-
         component pass below then correctly removes the fragments as orphans. */
      var thresh=alphaThresh!=null?alphaThresh:(aggressive?20:8);
      for(var i=3;i<d.length;i+=4){if(d[i]<thresh)d[i]=0;}
      if(aggressive){
        var alpha=new Uint8Array(w*h);
        for(var j=0;j<w*h;j++)alpha[j]=d[j*4+3]>0?1:0;
        var labels=new Int32Array(w*h),labelId=0,labelSizes=[];
        for(var j2=0;j2<w*h;j2++){
          if(alpha[j2]===0||labels[j2]!==0)continue;
          labelId++;
          var qq=[j2],sz=0;
          while(qq.length){
            var p=qq.pop();
            if(p<0||p>=w*h||alpha[p]===0||labels[p]!==0)continue;
            labels[p]=labelId;sz++;
            var px=p%w,py=Math.floor(p/w);
            if(px>0)qq.push(p-1);
            if(px<w-1)qq.push(p+1);
            if(py>0)qq.push(p-w);
            if(py<h-1)qq.push(p+w);
          }
          labelSizes.push({id:labelId,size:sz});
        }
        if(labelSizes.length>1){
          labelSizes.sort(function(a,b){return b.size-a.size;});
          var keepId=labelSizes[0].id;
          for(var j3=0;j3<w*h;j3++){
            if(labels[j3]!==0&&labels[j3]!==keepId)d[j3*4+3]=0;
          }
        }
        for(var y2=1;y2<h-1;y2++){
          for(var x2=1;x2<w-1;x2++){
            var idx2=y2*w+x2;
            if(d[idx2*4+3]===0)continue;
            var nT=0,nO=0;
            var nb=[idx2-1,idx2+1,idx2-w,idx2+w,idx2-w-1,idx2-w+1,idx2+w-1,idx2+w+1];
            for(var ni=0;ni<nb.length;ni++){
              var np=nb[ni];
              if(np>=0&&np<w*h){if(d[np*4+3]===0)nT++;else nO++;}
            }
            if(nT>0&&nO>0){
              var ratio2=nO/(nT+nO);
              d[idx2*4+3]=Math.round(d[idx2*4+3]*Math.min(1,ratio2*1.5));
            }
          }
        }
      }
      ctx.putImageData(id,0,0);
      var ni2=new Image();
      ni2.onload=function(){URL.revokeObjectURL(url);resolve(ni2);};
      ni2.onerror=function(){reject(new Error('cleanup failed'));};
      ni2.src=c.toDataURL('image/png');
    };
    img.onerror=function(){reject(new Error('cleanup load failed'));};
    img.src=url;
  });
};

window._sl2LIC=function(c){return new Promise(function(res,rej){var i=new Image();i.onload=function(){res(i);};i.onerror=rej;i.src=c.toDataURL('image/png');});};


/* bust-1777572546466844100 */

/* After an erase/fill stroke, the Fabric image's bounding box still extends
   over the now-transparent area. This helper crops the image's underlying
   canvas to the alpha-tight bounds and shifts the Fabric image so its visible
   centroid stays put on screen. Result: subsequent autoFitView centers correctly. */
window._sl2RecenterAfterEdit=function(){
  var st=window._sl2St;
  if(!st||!st.canvas||st.shape==='dtf')return;
  var img=st.canvas.getObjects('image')[0];
  if(!img)return;
  var el=img._element;
  if(!el)return;
  var w=el.width||el.naturalWidth, h=el.height||el.naturalHeight;
  if(!w||!h)return;
  var tc=document.createElement('canvas');
  tc.width=w;tc.height=h;
  var tctx=tc.getContext('2d');
  try{tctx.drawImage(el,0,0);}catch(e){return;}
  var data;
  try{data=tctx.getImageData(0,0,w,h).data;}catch(e){return;}
  var minX=w,minY=h,maxX=-1,maxY=-1;
  for(var y=0;y<h;y++){
    for(var x=0;x<w;x++){
      if(data[(y*w+x)*4+3]>8){
        if(x<minX)minX=x;
        if(y<minY)minY=y;
        if(x>maxX)maxX=x;
        if(y>maxY)maxY=y;
      }
    }
  }
  if(maxX<0)return; /* nothing visible */
  var pad=2;
  minX=Math.max(0,minX-pad);minY=Math.max(0,minY-pad);
  maxX=Math.min(w-1,maxX+pad);maxY=Math.min(h-1,maxY+pad);
  var newW=maxX-minX+1, newH=maxY-minY+1;
  if(newW===w&&newH===h)return; /* no crop needed */
  var newCanvas=document.createElement('canvas');
  newCanvas.width=newW;newCanvas.height=newH;
  var nctx=newCanvas.getContext('2d');
  nctx.drawImage(el,-minX,-minY);
  /* Binarize alpha: anything translucent (anti-aliased edge pixels, brush-cap fades)
     becomes fully opaque or fully transparent. Eliminates the wavy halo around shapes
     like icon PNGs and gives the cutline tracer hard parallel edges. */
  try{
    var idata=nctx.getImageData(0,0,newW,newH), pix=idata.data;
    for(var bi=3;bi<pix.length;bi+=4)pix[bi]=pix[bi]>=128?255:0;
    nctx.putImageData(idata,0,0);
  }catch(e){console.error('[recenter] binarize failed',e);}
  /* Shift in image-local coords (origin at image center) */
  var contentCenterX=(minX+maxX)/2 - w/2;
  var contentCenterY=(minY+maxY)/2 - h/2;
  var sx=img.scaleX||1, sy=img.scaleY||1;
  var ang=(img.angle||0)*Math.PI/180;
  var cos=Math.cos(ang), sin=Math.sin(ang);
  /* Apply scale then rotation to get canvas-space delta */
  var dx=contentCenterX*sx, dy=contentCenterY*sy;
  var canvasDx=dx*cos - dy*sin;
  var canvasDy=dx*sin + dy*cos;
  img.left=(img.left||0)+canvasDx;
  img.top=(img.top||0)+canvasDy;
  img._element=newCanvas;
  img._originalElement=newCanvas;
  img.width=newW;
  img.height=newH;
  img.dirty=true;
  img.setCoords();
  st.canvas.requestRenderAll();
};

/* ══════════ AI IMAGE GENERATION (Flux Schnell via Cloudflare Workers AI) ══════════
   Calls the print-api worker's /generate endpoint which runs Flux Schnell on
   Cloudflare's GPU pool. Server adds sticker-style prompt suffix; per-IP daily
   rate limit is enforced server-side. Returns a fabric.Image dropped onto the
   canvas. */
(function(){
  var ENDPOINT='https://print-api.stickermint.workers.dev/generate';

  function _ensureCanvas(){
    var st=window._sl2St;
    if(st&&st.canvas)return Promise.resolve(st);
    if(window._sl2IB){try{window._sl2IB();}catch(e){}}
    return new Promise(function(res,rej){
      var tries=0;
      var iv=setInterval(function(){
        var st2=window._sl2St;
        if(st2&&st2.canvas){clearInterval(iv);res(st2);}
        else if(++tries>100){clearInterval(iv);rej(new Error('Canvas init timed out. Try uploading any image first to start the studio.'));}
      },50);
    });
  }

  window._sl2AIGen=function(prompt,style){
    return new Promise(function(resolve,reject){
      _ensureCanvas().then(function(st){
      if(!st||!st.canvas){reject(new Error('Studio not ready'));return;}
      if(!prompt||typeof prompt!=='string'||prompt.trim().length<2){
        reject(new Error('Prompt required (2+ chars)'));return;
      }
      fetch(ENDPOINT,{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({prompt:prompt.trim(),style:style||''}),
      }).then(function(r){
        if(!r.ok){
          return r.json().then(function(j){throw new Error(j.error||('HTTP '+r.status));},function(){throw new Error('HTTP '+r.status);});
        }
        return r.blob();
      }).then(function(blob){
        var url=URL.createObjectURL(blob);
        var img=new Image();
        img.onload=function(){
          /* Strip the (near-)white background Flux generates so the cutline can
             trace the actual subject. _sl2RemoveSolidBg samples corner pixels to
             pick the bg color, then flood-fills + alpha-clears matching pixels.
             Falls back to raw image if helper isn't loaded. */
          var src=img;
          try{
            if(window._sl2RemoveSolidBg){
              var cleaned=window._sl2RemoveSolidBg(img);
              if(cleaned&&cleaned.width)src=cleaned;
            }
          }catch(e){console.warn('[ai-bgrm]',e);}
          var c=st.canvas,cw=c.getWidth(),ch=c.getHeight();
          var sW=src.width||img.width,sH=src.height||img.height;
          var maxSide=Math.min(cw,ch)*0.7;
          var s=Math.min(maxSide/sW,maxSide/sH,1);
          /* Make AI image the main image only if there isn't one yet — lets
             users add AI elements alongside an existing logo as overlays. */
          var hasMain=c.getObjects().some(function(o){return o._isMainImage&&o.visible!==false;});
          var fImg=new fabric.Image(src,{
            left:cw/2,top:ch/2,originX:'center',originY:'center',
            scaleX:s,scaleY:s,_isMainImage:!hasMain,_dtfName:(function(p){p=p.trim().replace(/\s+/g,' ').slice(0,40);return p.charAt(0).toUpperCase()+p.slice(1);})(prompt)
          });
          c.add(fImg);c.setActiveObject(fImg);c.renderAll();
          if(window._sl2RB)window._sl2RB();
          if(window._sl2SS){if(st.shape==='dtf'&&window.DTF)setTimeout(function(){if(!fImg._dtfPlaced&&!fImg._dtfNorm)window._sl2SS();},60);else window._sl2SS();}
          if(window._sl2DC&&st.shape==='die-cut'){
            requestAnimationFrame(function(){try{window._sl2DC();}catch(e){}});
          }
          resolve(fImg);
        };
        img.onerror=function(){reject(new Error('Failed to load image'));};
        img.src=url;
      }).catch(reject);
      },reject);
    });
  };

  /* Inject an "AI Image" button into the desktop add-content toolbar (next to
     btnClipart) and a corresponding entry in the mobile Add sheet. Auto-runs
     once the toolbar exists. Safe to call multiple times — no-op if already
     injected. */
  function _injectBtn(){
    if(document.getElementById('btnSl2AI'))return;
    var ref=document.getElementById('btnClipart')||document.getElementById('btnAddText')||document.getElementById('btnAddImage');
    if(!ref||!ref.parentNode)return setTimeout(_injectBtn,300);
    var b=document.createElement('button');
    b.id='btnSl2AI';
    b.className=ref.className+' sms-ai-action';
    b.title='Generate image with AI';
    b.innerHTML='<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/><circle cx="12" cy="12" r="3"/></svg><span>AI Image</span>';
    b.addEventListener('click',function(){
      var st=window._sl2St;
      if((!st||!st.canvas)&&window._sl2IB){try{window._sl2IB();}catch(e){}}
      setTimeout(function(){window._sl2AIGenUI();},120);
    });
    ref.parentNode.insertBefore(b,ref.nextSibling);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',_injectBtn);
  else _injectBtn();
  /* Re-check periodically in case the toolbar mounts after our initial run
     (e.g. async template flow). Stops after 10 attempts. */
  var _injTries=0,_injIv=setInterval(function(){
    if(document.getElementById('btnSl2AI')||_injTries++>10){clearInterval(_injIv);return;}
    _injectBtn();
  },500);

  /* Simple modal UI. Call window._sl2AIGenUI() to open. */
  window._sl2AIGenUI=function(){
    var old=document.getElementById('sl2-aigen-ol');if(old)old.remove();
    var styles=['cartoon','watercolor','neon','vintage','minimal','chibi'];
    var ol=document.createElement('div');
    ol.id='sl2-aigen-ol';
    ol.className='sms';
    ol.style.cssText='position:fixed;inset:0;z-index:999999998;background:rgba(15,20,28,0.82);backdrop-filter:blur(6px);display:flex;align-items:center;justify-content:center;padding:16px;';
    ol.innerHTML='<div style="background:#fff;border-radius:14px;width:100%;max-width:460px;padding:18px 20px;box-shadow:0 30px 80px rgba(0,0,0,.45);">'
      +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;"><h3 style="margin:0;font-size:16px;font-weight:800;">AI Image Generator</h3><button id="sl2agX" style="background:none;border:none;font-size:22px;color:#999;cursor:pointer;line-height:1;">&times;</button></div>'
      +'<p style="font-size:12px;color:#666;margin:0 0 10px;line-height:1.4;">'+(window.DTF?'Describe your design. Be specific. We remove the plain background it is drawn on, so it is ready for your gang sheet.':'Describe your sticker. Be specific. The AI will add sticker-style finishing automatically.')+'</p>'
      +'<textarea id="sl2agP" placeholder="e.g. a smiling robot holding a coffee cup" style="width:100%;min-height:70px;padding:10px;border:1.5px solid #e0e4e9;border-radius:8px;font-size:13px;font-family:inherit;resize:vertical;box-sizing:border-box;"></textarea>'
      +'<div style="margin-top:10px;font-size:11px;font-weight:700;color:#666;text-transform:uppercase;letter-spacing:.5px;">Style</div>'
      +'<div id="sl2agS" style="display:flex;flex-wrap:wrap;gap:6px;margin-top:6px;">'
        +'<button data-style="" class="sl2-ag-chip sl2-ag-active">none</button>'
        +styles.map(function(s){return '<button data-style="'+s+'" class="sl2-ag-chip">'+s+'</button>';}).join('')
      +'</div>'
      +'<div id="sl2agM" style="margin-top:10px;min-height:18px;font-size:12px;color:#9b1c1c;"></div>'
      +'<div style="display:flex;gap:8px;margin-top:14px;">'
        +'<button id="sl2agCx" style="flex:0 0 auto;padding:10px 14px;background:#fff;border:1.5px solid #e0e4e9;border-radius:8px;font-size:13px;font-weight:700;color:#555;cursor:pointer;">Cancel</button>'
        +'<button id="sl2agGo" style="flex:1;padding:10px 14px;background:linear-gradient(135deg,#00d2b0,#00a087);color:#fff;border:none;border-radius:8px;font-size:13px;font-weight:800;cursor:pointer;letter-spacing:.3px;">Generate</button>'
      +'</div>'
      +'<style>.sl2-ag-chip{padding:5px 10px;background:#f7f9fb;border:1.5px solid #e3e6ea;border-radius:6px;font-size:11px;font-weight:700;color:#666;cursor:pointer;text-transform:capitalize;}.sl2-ag-chip.sl2-ag-active{background:#00c9a7;border-color:#00c9a7;color:#fff;}</style>'
      +'</div>';
    document.body.appendChild(ol);

    var sel='';
    ol.querySelectorAll('.sl2-ag-chip').forEach(function(b){
      b.addEventListener('click',function(){
        ol.querySelectorAll('.sl2-ag-chip').forEach(function(o){o.classList.remove('sl2-ag-active');});
        b.classList.add('sl2-ag-active');
        sel=b.dataset.style||'';
      });
    });

    function close(){ol.remove();}
    ol.querySelector('#sl2agX').onclick=close;
    ol.querySelector('#sl2agCx').onclick=close;
    ol.addEventListener('click',function(e){if(e.target===ol)close();});

    ol.querySelector('#sl2agGo').onclick=function(){
      var p=ol.querySelector('#sl2agP').value.trim();
      var msgEl=ol.querySelector('#sl2agM');
      var goBtn=ol.querySelector('#sl2agGo');
      if(p.length<2){msgEl.style.color='#9b1c1c';msgEl.textContent='Add more detail (2+ chars).';return;}
      goBtn.disabled=true;
      var origText=goBtn.textContent;
      goBtn.textContent='Generating…';
      msgEl.style.color='#666';
      msgEl.textContent='Calling Flux Schnell (this takes 2–5 sec)…';
      window._sl2AIGen(p,sel).then(function(){close();}).catch(function(err){
        goBtn.disabled=false;
        goBtn.textContent=origText;
        msgEl.style.color='#9b1c1c';
        msgEl.textContent=err.message||'Generation failed';
      });
    };
    setTimeout(function(){ol.querySelector('#sl2agP').focus();},50);
  };
})();
